<!--
 * @Author:
 * @Description: 实体管理
 -->
<template>
  <div id="classList" class="h-full">
    <el-row :gutter="10" class="flex h-full">
      <!-- 实体 -->
      <el-col :span="6" id="leftCol" class="h-full" v-show="isShowTreeMode">
        <el-card class="w-full h-full relative">
          <el-row class="leftTop border-bottom-1px pb-10px" :gutter="10">
            <el-col :span="24" class="flex">
              <selectStandardId
                :selectStandardProps="selectStandardProps"
                @updateStandardId="updateStandardId"
              />
              <el-input
                size="small"
                class="mx-10px"
                @keyup.enter.native="searchClass"
                v-model.trim="classKeyword"
                :placeholder="`${$t('pleaseEnterCodeOrName')}`"
                clearable
              ></el-input>
              <!-- <el-button type="primary" @click="searchClass">{{ $t('search') }}</el-button> -->
              <el-button type="primary" icon="el-icon-search" @click="searchClass"></el-button>
            </el-col>
          </el-row>
          <div class="w-full my-10px text-14px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-16px leading-28px"
              >实体树</span
            >
            <div class="float-right">
              <!-- 新增 -->
              <el-tooltip :content="`${$t('create')}`" placement="top">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-circle-plus"
                  class="!text-16px !px-5px"
                  :disabled="!$hasAccess('create')"
                  @click="addClass"
                ></el-button>
              </el-tooltip>
              <!-- 删除 -->
              <el-tooltip :content="`${$t('delete')}`" placement="top">
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  class="!text-16px !px-5px"
                  :disabled="!$hasAccess('delete') || selectPublishCalss"
                  @click="deleteClass()"
                ></el-button>
              </el-tooltip>
              <!-- 发布 -->
              <el-tooltip
                :content="
                  publishLoading && getProgress
                    ? `当前发布进度:${currentProgress}`
                    : `${$t('publish')}`
                "
                placement="top"
              >
                <div class="inline-block relative mx-10px">
                  <squareProgress
                    :percentage="currentProgress"
                    :strokeWidth="4"
                    :borderRadius="4"
                    :size="30"
                    backgroundColor="transparent"
                    color="#0082ff"
                    class="!absolute -top-1px -left-1px z-10"
                    v-if="publishLoading && getProgress"
                  ></squareProgress>
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-success"
                    class="!text-16px !px-5px"
                    :disabled="!$hasAccess('publish')"
                    @click="batchPublish"
                    :loading="publishLoading"
                  ></el-button>
                </div>
              </el-tooltip>
              <!-- 未发布 -->
              <el-tooltip :content="`${$t('canCelPublish')}`" placement="top">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-remove"
                  class="!text-16px !px-5px"
                  :disabled="!$hasAccess('unpublish')"
                  @click="cancelPublish"
                  :loading="unpublishLoading"
                ></el-button>
              </el-tooltip>
              <!-- 导出 -->
              <el-tooltip :content="`${$t('export')}`" placement="top">
                <el-button
                  size="mini"
                  icon="el-icon-download"
                  class="!text-16px !px-5px"
                  @click="exportFile"
                  :disabled="!$hasAccess('export')"
                ></el-button>
              </el-tooltip>
              <!-- 导入 -->
              <el-tooltip :content="`${$t('import')}`" placement="top">
                <el-button
                  size="mini"
                  icon="el-icon-upload2"
                  class="!text-16px !px-5px"
                  @click="importFile"
                  :disabled="!$hasAccess('import')"
                ></el-button>
              </el-tooltip>
            </div>
          </div>
          <!-- 实体树 -->
          <div
            v-loading="classListLoading"
            class="w-full mt-20px h-[calc(100%-128px)] overflow-y-auto"
          >
            <el-tree
              ref="classTree"
              :props="classPros"
              :load="loadClassTreeNode"
              :data="tableClassData"
              :expand-on-click-node="false"
              lazy
              show-checkbox
              highlight-current
              node-key="id"
              :check-strictly="true"
              @check-change="classCheckChange"
              @node-click="handleCurrentChange"
            >
              <div slot-scope="{ node, data }" class="w-[calc(100%-64px)] text-overflow relative">
                <el-tooltip
                  :content="`${node.label}（${data.name}）`"
                  placement="top"
                  :disabled="isShowTooltip"
                >
                  <span
                    class="text-overflow mt-2px"
                    :class="`treeTooltip${data.id}`"
                    @mousemove="classTreeMouseOver(`treeTooltip${data.id}`)"
                  >
                    <i
                      class="text-16px color-primary-dark"
                      :class="data.approveStatus === 0 ? 'el-icon-unlock' : 'el-icon-lock'"
                    ></i>
                    {{ node.label }}({{ data.name }})
                  </span>
                </el-tooltip>
                <div class="absolute right-[-10px] top-7px" @click.stop>
                  <el-dropdown
                    trigger="hover"
                    @command="($event) => handleCommand($event, data)"
                    size="mini"
                  >
                    <span class="el-dropdown-link">
                      <i class="el-icon-more text-12px transform-rotate-90 pt-10px"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="view" :disabled="!$hasAccess('read')">{{
                        $t('view')
                      }}</el-dropdown-item>
                      <el-dropdown-item
                        command="update"
                        :disabled="!$hasAccess('update') || data.approveStatus !== 0"
                        >{{ $t('edit') }}</el-dropdown-item
                      >
                      <el-dropdown-item
                        v-if="!['Tag', 'Document'].includes(data.code)"
                        command="delete"
                        :disabled="!$hasAccess('delete')"
                        >{{ $t('delete') }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </el-tree>
          </div>
          <div v-if="isShowTreeMode" class="absolute right-0 top-1/2" @click="changeTreeMode">
            <i class="iconfont icon-bg-circleLeft text-24px"></i>
          </div>
        </el-card>
      </el-col>
      <!-- 属性 -->
      <el-col :span="isShowTreeMode ? 18 : 24" class="h-full">
        <el-card class="h-full overflow-y-auto relative">
          <div class="absolute left-0 top-1/2 z-99" v-if="!isShowTreeMode" @click="changeTreeMode">
            <i class="iconfont icon-bg-circleRight text-24px"></i>
          </div>
          <el-tabs v-model="attrActiveName" class="w-full" @tab-click="handleTabClick">
            <el-tab-pane label="属性" name="attribute"></el-tab-pane>
            <el-tab-pane label="属性分组" name="attrGrouping"></el-tab-pane>
            <el-tab-pane label="变更记录" name="changelog"></el-tab-pane>
            <el-tab-pane label="落地存储" name="floorStorage"></el-tab-pane>
          </el-tabs>
          <!-- 属性 -->
          <div v-if="attrActiveName === 'attribute'" class="h-[calc(100%-40px)]">
            <div class="w-full flex">
              <el-input
                size="small"
                class="mr-10px"
                style="width: 220px"
                v-model.trim="attrKeyword"
                @keyup.enter.native="searchAttr"
                :placeholder="`${$t('pleaseEnterCodeOrName')}`"
                clearable
              ></el-input>
              <el-button type="primary" @click="searchAttr">{{ $t('search') }}</el-button>
              <el-button
                type="primary"
                :disabled="!$hasAccess('create') || classStatus !== 0"
                @click="addAttr"
                >{{ $t('create') }}</el-button
              >
              <el-button
                type="danger"
                :disabled="!$hasAccess('delete') || classStatus !== 0"
                @click="delMoreAttr"
                >{{ $t('delete') }}</el-button
              >
              <el-button
                type="primary"
                :loading="effectLoading"
                @click="openEffectAnalysis('effect')"
                >影响分析</el-button
              >
              <el-button type="primary" :loading="bloodLoading" @click="openEffectAnalysis('blood')"
                >血缘分析</el-button
              >
              <columnVisible
                :options="columnVisibleOptionsAttr"
                class="ml-10px"
                :name="['attrColumnVisible']"
                :defaultValue="columnVisibleAttr"
                @columnVisibleChanged="changeColumnAttr"
              ></columnVisible>
            </div>
            <div class="h-[calc(100%-120px)] mt-20px">
              <el-table
                :data="tableAttrData"
                v-loading="attrListLoading"
                ref="attrTable"
                class="w-full"
                :highlight-current-row="true"
                @selection-change="handleSelectionChange"
                stripe
                height="100%"
                border
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  v-for="item in tableAttrFilterHeader"
                  :key="item.label"
                  :label="`${$t(item.label)}`"
                  :prop="item.value"
                  :width="item.width"
                  :show-overflow-tooltip="true"
                  sortable
                >
                  <template slot-scope="scope">
                    <span v-if="item.isAction">
                      {{ scope.row.dynamicColumnData[item.seqNo].value }}
                    </span>
                    <span v-else-if="item.isCheckBox">
                      <el-checkbox v-model="scope.row[item.value]" disabled></el-checkbox>
                    </span>
                    <span v-else>{{ scope.row[item.value] }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="`${$t('operate')}`" width="200" fixed="right">
                  <template slot-scope="scope">
                    <el-button
                      @click="viewAttr(scope.row)"
                      size="mini"
                      :disabled="!$hasAccess('read')"
                      >{{ $t('view') }}</el-button
                    >
                    <el-button
                      :disabled="!$hasAccess('update') || classStatus !== 0 || scope.row.disabled"
                      @click="editAttr(scope.row.id)"
                      size="mini"
                      >{{ $t('edit') }}</el-button
                    >
                    <el-button
                      :disabled="!$hasAccess('delete') || classStatus !== 0 || scope.row.disabled"
                      @click="delAttr(scope.row.id)"
                      size="mini"
                      >{{ $t('delete') }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="mt-20px pb-10px float-right pagination">
                <el-pagination
                  background
                  @current-change="handleCurrentChangeAttr"
                  @size-change="handleSizeChangeAttr"
                  :current-page.sync="pageNoAttr"
                  :page-size="pageSizeAttr"
                  :page-sizes="$pageSizeAll"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="recordCountAttr"
                ></el-pagination>
              </div>
            </div>
          </div>
          <!-- 属性分组 -->
          <div v-if="attrActiveName === 'attrGrouping'" class="w-full h-[calc(100%-34px)]">
            <el-row :gutter="20" class="h-full">
              <!-- 分组树 -->
              <el-col :span="6" class="h-[calc(100%-20px)] border-1px !pl-0">
                <div class="w-full pt-10px pb-20px flex justify-between">
                  <el-input
                    size="small"
                    class="mr-10px ml-10px"
                    @keyup.enter.native="searchClass"
                    v-model.trim="classKeyword"
                    :placeholder="$t('PleaseEnterAKeyword')"
                    clearable
                  ></el-input>
                  <el-button type="primary" icon="el-icon-search"></el-button>
                </div>
                <div class="w-full h-[calc(100%-66px)] overflow-y-auto">
                  <div class="w-full flex justify-between">
                    <p class="text-14px pl-20px !leading-28px">属性分组({{ attrGroups.length }})</p>
                    <el-button
                      icon="el-icon-circle-plus"
                      class="!text-16px !px-5px"
                      type="primary"
                      size="mini"
                      @click="addAttrGroups('create')"
                      :disabled="classStatus !== 0"
                    ></el-button>
                  </div>
                  <div class="w-full pt-10px h-[calc(100%-38px)] overflow-y-auto">
                    <el-tree
                      :data="attrGroups"
                      :props="attrGroupProps"
                      ref="attrGroupTree"
                      @node-click="groupNodeClick"
                    >
                      <div
                        slot-scope="{ node, data }"
                        class="w-[calc(100%-26px)] text-overflow relative"
                      >
                        <el-tooltip
                          placement="top"
                          :content="`${node.label}`"
                          :disabled="isShowTooltip"
                        >
                          <span
                            class="text-overflow"
                            :class="`treeTooltip${data.id}`"
                            @mousemove="classTreeMouseOver(`treeTooltip${data.id}`)"
                          >
                            {{ node.label }}
                          </span>
                        </el-tooltip>
                        <div class="absolute right-0 top-0" @click.stop>
                          <el-dropdown
                            v-if="node.label !== '未分组'"
                            trigger="click"
                            @command="($event) => handleCommand($event, data)"
                            class="ml-10px"
                            size="mini"
                          >
                            <i
                              class="el-icon-more text-12px transform-rotate-90 text-[#515a6e]"
                            ></i>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item
                                command="groupUpdate"
                                :disabled="
                                  classStatus !== 0 ||
                                    (selectedGroup.length > 0 && selectedGroup[0] === '未分组') ||
                                    groupClassDisabled
                                "
                                >{{ $t('edit') }}</el-dropdown-item
                              >
                              <el-dropdown-item
                                command="groupDelete"
                                :disabled="
                                  classStatus !== 0 ||
                                    (selectedGroup.length > 0 && selectedGroup[0] === '未分组') ||
                                    groupClassDisabled
                                "
                                >{{ $t('delete') }}</el-dropdown-item
                              >
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                    </el-tree>
                  </div>
                </div>
              </el-col>
              <!-- 分组列表 -->
              <el-col :span="18" class="h-full">
                <div class="w-full flex">
                  <el-input
                    size="small"
                    class="mr-10px"
                    style="width: 220px"
                    v-model.trim="attrKeyword"
                    @keyup.enter.native="searchAttr"
                    :placeholder="`${$t('pleaseEnterCodeOrName')}`"
                    clearable
                  ></el-input>
                  <el-button type="primary" @click="searchAttr">{{ $t('search') }}</el-button>
                  <el-button
                    type="danger"
                    :disabled="!$hasAccess('delete') || classStatus !== 0 || groupClassDisabled"
                    @click="delMoreAttr"
                    >{{ $t('delete') }}</el-button
                  >
                  <el-button
                    type="primary"
                    class="ml-10px"
                    @click="divideGroup"
                    :disabled="classStatus !== 0 || groupClassDisabled"
                    >{{ $t('grouping') }}</el-button
                  >
                </div>
                <div class="h-[calc(100%-120px)] mt-20px">
                  <el-table
                    :data="tableAttrData"
                    v-loading="attrListLoading"
                    ref="attrTable"
                    class="w-full"
                    :highlight-current-row="true"
                    @selection-change="handleSelectionChange"
                    stripe
                    height="100%"
                    border
                  >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column
                      v-for="item in tableGroupHeader"
                      :key="item.label"
                      :label="`${$t(item.label)}`"
                      :prop="item.value"
                      :width="item.width"
                      :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope">
                        <span v-if="item.isAction">
                          {{ scope.row.dynamicColumnData[item.seqNo].value }}
                        </span>
                        <span v-else-if="item.isCheckBox">
                          <el-checkbox v-model="scope.row[item.value]" disabled></el-checkbox>
                        </span>
                        <span v-else>{{ scope.row[item.value] }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column :label="`${$t('operate')}`" width="140" fixed="right">
                      <template slot-scope="scope">
                        <!-- <el-button
                          @click="viewAttr(scope.row)"
                          size="mini"
                          :disabled="!$hasAccess('read')"
                          >{{ $t('view') }}</el-button
                        > -->
                        <el-button
                          :disabled="
                            !$hasAccess('update') ||
                              classStatus !== 0 ||
                              groupClassDisabled ||
                              scope.row.disabled
                          "
                          @click="editAttr(scope.row.id)"
                          size="mini"
                          >{{ $t('edit') }}</el-button
                        >
                        <el-button
                          :disabled="
                            !$hasAccess('delete') ||
                              classStatus !== 0 ||
                              groupClassDisabled ||
                              scope.row.disabled
                          "
                          @click="delAttr(scope.row.id)"
                          size="mini"
                          >{{ $t('delete') }}</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="mt-20px pb-10px float-right pagination">
                    <el-pagination
                      background
                      @current-change="handleCurrentChangeAttr"
                      @size-change="handleSizeChangeAttr"
                      :current-page.sync="pageNoAttr"
                      :page-size="pageSizeAttr"
                      :page-sizes="$pageSizeAll"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="recordCountAttr"
                    ></el-pagination>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 变更记录 -->
          <div v-if="attrActiveName === 'changelog'" class="h-[calc(100%-40px)]">
            <el-select
              v-model="changelogSearchForm.changeType"
              placeholder="请选择变更类型"
              class="w-200px mr-10px"
              size="small"
              filterable
              clearable
            >
              <el-option
                v-for="item in changeTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
              size="small"
              class="mr-10px"
              style="width: 220px"
              v-model.trim="changelogSearchForm.keyword"
              placeholder="搜索关键字"
              clearable
            ></el-input>
            <el-button type="primary" @click="changeLogSearch">{{ $t('search') }}</el-button>
            <el-table
              :data="changeLogList"
              ref="changeTable"
              class="w-full h-[calc(100%-120px)] mt-20px overflow-auto"
              v-loading="changeLoading"
              :highlight-current-row="true"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              border
            >
              <el-table-column type="index" width="50" :label="$t('serialNumber')">
                <template slot-scope="scope">
                  <div>
                    {{ scope.$index + 1 + (changeLogPage.pageNo - 1) * changeLogPage.pageSize }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="`${$t('changeType')}`"
                prop="changeTypeName"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                :label="`${$t('changeRecords')}`"
                prop="remark"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                :label="`${$t('changeUser')}`"
                prop="createdUserName"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                :label="`${$t('changeTime')}`"
                prop="lastModifiedTime"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column :label="`${$t('operate')}`" width="120">
                <template slot-scope="scope">
                  <el-button @click="viewChangeDetail(scope.row.id)" size="mini">{{
                    $t('view')
                  }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-20px pb-10px float-right pagination">
              <el-pagination
                background
                @current-change="getChangeLogList"
                @size-change="changeLogSizeChange"
                :current-page.sync="changeLogPage.pageNo"
                :page-size="changeLogPage.pageSize"
                :page-sizes="$pageSizeAll"
                layout="total, sizes, prev, pager, next, jumper"
                :total="changeLogPage.total"
              ></el-pagination>
            </div>
          </div>
          <!-- 落地存储 -->
          <div v-if="attrActiveName === 'floorStorage'" class="h-[calc(100%-40px)]">
            <div class="mb-20px">落地表名：{{ currentStorage.tableName }}</div>
            <div class="table-box !h-[calc(100%-100px)]">
              <el-table
                :data="tableStorageData"
                v-loading="storageLoading"
                ref="storageTable"
                class="w-full h-full"
                :highlight-current-row="true"
                :header-cell-style="{ textAlign: 'center' }"
                :cell-style="{ textAlign: 'center' }"
                stripe
                border
              >
                <el-table-column
                  v-for="item in storageHeader"
                  :key="item.label"
                  :label="`${$t(item.label)}`"
                  :prop="item.value"
                  :width="item.width"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span v-if="item.isAction">
                      {{ scope.row.dynamicColumnData[item.seqNo].value }}
                    </span>
                    <span v-else-if="item.isCheckBox">
                      <el-checkbox v-model="scope.row[item.value]" disabled></el-checkbox>
                    </span>
                    <span v-else>{{ scope.row[item.value] }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="mt-10px float-right pagination">
              <el-pagination
                background
                @current-change="handleCurrentChangeStorage"
                @size-change="handleSizeChangeStorage"
                :current-page.sync="pageNoStorage"
                :page-size="pageSizeStorage"
                :page-sizes="$pageSizeAll"
                layout="total, sizes, prev, pager, next"
                :total="recordCountStorage"
              ></el-pagination>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- 新增/编辑实体弹框 -->
    <el-dialog
      :title="classTitle"
      :visible.sync="classDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      v-dialogDrag
      width="1000px"
    >
      <el-form
        label-width="150px"
        ref="classForm"
        :rules="currentLang === 'zh-Hans' ? classFormRules : classFormEnRules"
        :model="classForm"
        label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="`${$t('classCode')}`" prop="code" class="w-full">
              <el-input
                :disabled="classTitle === $t('classDetail')"
                size="small"
                @input="onInput"
                clearable
                v-model.trim="classForm.code"
                maxlength="30"
                show-word-limit
                :placeholder="$t('pleaseEnter')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('className')" prop="name" class="w-full">
              <el-input
                size="small"
                clearable
                v-model.trim="classForm.name"
                :disabled="classTitle === $t('classDetail')"
                maxlength="30"
                show-word-limit
                :placeholder="$t('pleaseEnter')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="`${$t('parentClass')}`" prop="parentId">
              <el-select
                :disabled="classForm.isType || classTitle === $t('classDetail')"
                v-model="classForm.parentId"
                clearable
                filterable
                class="w-full"
                :placeholder="`${$t('pleaseSelect')}`"
                size="small"
              >
                <el-option
                  v-for="item in _.filter(parentTypeList, (item) => {
                    return item.id !== currentClassRowId
                  })"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('seqNo')" prop="seqNo">
              <el-input
                :disabled="classTitle === $t('classDetail')"
                size="small"
                class="w-full"
                clearable
                v-model.trim="classForm.seqNo"
                :placeholder="$t('pleaseEnter')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('whetherItIisAtypeOrNot')" prop="isType">
              <div class="flex">
                <el-checkbox
                  v-model="classForm.isType"
                  class="!mr-10px"
                  :disabled="classTitle === $t('classDetail') || isPublished"
                  @change="changeIsType"
                ></el-checkbox>
                <el-select
                  :disabled="classForm.isType || classTitle === $t('classDetail') || isPublished"
                  v-model="classForm.stdClassTypeAttributeCateId"
                  :placeholder="$t('pleaseSelectABusinessType')"
                  class="flex-1"
                  size="small"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in classTypeAttributeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('mainData')" prop="isMainData">
              <div class="flex">
                <!-- <el-checkbox
                  v-model="classForm.isMainData"
                  class="!mr-10px"
                  :disabled="classTitle === $t('classDetail')"
                  @change="changeIsMainData"
                ></el-checkbox> -->
                <el-select
                  size="small"
                  :disabled="classTitle === $t('classDetail')"
                  clearable
                  filterable
                  v-model="classForm.dataMainTypeId"
                  :placeholder="$t('pleaseSelectMasterDataType')"
                  class="flex-1"
                  @change="changeMainData"
                >
                  <el-option
                    v-for="(item, index) in mainDataTypeList"
                    :key="index"
                    :label="item.typeName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('topic')" prop="sourceSystem">
              <el-select
                v-model="classForm.subjectDomainId"
                clearable
                filterable
                class="w-full"
                :placeholder="$t('请选择主题')"
                size="small"
                :disabled="classTitle === $t('classDetail')"
              >
                <el-option
                  v-for="item in themeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('来源系统')" prop="sourceSystem">
              <el-input
                :disabled="classTitle === $t('classDetail')"
                size="small"
                class="w-full"
                clearable
                v-model.trim="classForm.sourceSystem"
                :placeholder="$t('pleaseEnter')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('label')" prop="classLabelIds">
              <el-select
                :disabled="classTitle === $t('classDetail')"
                v-model="classForm.classLabelIds"
                :placeholder="`${$t('pleaseSelect')}`"
                class="w-full"
                size="small"
                multiple
                :multiple-limit="10"
                filterable
                clearable
              >
                <el-option
                  v-for="item in classLabelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item :label="`${$t('infoType')}`">
              <el-select
                size="small"
                :disabled="classTitle === $t('classDetail')"
                clearable
                filterable
                v-model="classForm.infoType"
                :placeholder="`${$t('pleaseSelect')}`"
                class="w-full"
              >
                <el-option label="文档" :value="1"> </el-option>
                <el-option label="对象" :value="0"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('tableName')}`" prop="tableName">
              <el-input
                :readonly="classTitle === $t('classDetail')"
                size="small"
                class="w-full"
                clearable
                v-model.trim="classForm.tableName"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="12">
            <el-form-item :label="`${$t('identify')}`" prop="identifierIds">
              <el-select
                size="small"
                :disabled="classTitle === $t('classDetail')"
                clearable
                filterable
                v-model="classForm.identifierIds"
                :placeholder="`${$t('pleaseSelect')}`"
                class="w-full"
                multiple
                collapse-tags
              >
                <el-option
                  v-for="item in classRelationLabelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                  <span class="l m-r-10">{{ item.groupCodeIdentifierCode }}</span>
                  <span class="text-color-grey-ccc fz-14 r">{{ item.code }}-{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <div v-if="!actionClassList.length">
            <el-col
              :span="12"
              class="position-relative"
              v-for="(item, index) in classForm.dynamicColumnData"
              :key="index"
            >
              <el-form-item :label="item.actualAttributeColumnName" class="w-full">
                <el-input
                  size="small"
                  :readonly="classTitle === $t('classDetail')"
                  clearable
                  v-model.trim="item.value"
                  v-if="item.valueType === 1"
                ></el-input>
                <el-select
                  size="small"
                  :disabled="classTitle === $t('classDetail')"
                  clearable
                  filterable
                  v-model="item.value"
                  v-if="item.valueType === 5"
                  :placeholder="`${$t('pleaseSelect')}`"
                  class="w-full"
                >
                  <el-option
                    v-for="it in item.actionArr"
                    :key="it.id"
                    :label="it.code"
                    :value="it.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </div>
          <div v-else>
            <el-col
              :span="12"
              class="position-relative"
              v-for="(item, index) in actionClassList"
              :key="index"
            >
              <el-form-item :label="item.actualAttributeColumnName" class="w-full">
                <el-input
                  size="small"
                  :readonly="classTitle === $t('classDetail')"
                  clearable
                  v-model.trim="item.value"
                  v-if="item.valueType === 1"
                ></el-input>
                <el-select
                  size="small"
                  :disabled="classTitle === $t('classDetail')"
                  clearable
                  filterable
                  v-model="item.value"
                  v-if="item.valueType === 5"
                  :placeholder="`${$t('pleaseSelect')}`"
                  class="w-full"
                >
                  <el-option
                    v-for="it in item.actionArr"
                    :key="it.id"
                    :label="it.name"
                    :value="it.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </div>
          <el-col :span="24">
            <el-form-item :label="`${$t('describe')}`" prop="description" class="w-full">
              <el-input
                :disabled="classTitle === $t('classDetail')"
                size="small"
                type="textarea"
                v-model.trim="classForm.description"
                :placeholder="$t('pleaseEnter')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="`${$t('remarks')}`" prop="remark" class="w-full">
              <el-input
                size="small"
                v-model.trim="classForm.remark"
                type="textarea"
                :disabled="classTitle === $t('classDetail')"
                :placeholder="$t('pleaseEnter')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-for="(item, index) in personalityMetaData" :key="index">
            <!-- 字符串，整数，小数 -->
            <el-form-item
              v-if="['1', '2', '3'].includes(item.dataType)"
              :label="item.name"
              class="w-full"
            >
              <el-input
                type="text"
                size="small"
                v-model.trim="item.dataValue"
                :max-length="item.dataType === '1' ? item.length : ''"
                :disabled="classTitle === $t('classDetail')"
                @input="metaDataInputChange($event, item.dataType, item)"
                clearable
              ></el-input>
            </el-form-item>
            <!-- 布尔 -->
            <el-form-item v-if="item.dataType === '4'" :label="item.name" class="w-full">
              <el-radio-group v-model="item.dataValue" :disabled="classTitle === $t('classDetail')">
                <el-radio label="true">是</el-radio>
                <el-radio label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 日期时间 -->
            <el-form-item v-if="item.dataType === '5'" :label="item.name" class="w-full">
              <el-date-picker
                v-model="item.dataValue"
                type="datetime"
                class="!w-full"
                :disabled="classTitle === $t('classDetail')"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer tc" v-if="classTitle !== $t('classDetail')">
        <el-button
          :loading="saveClassLoading"
          type="primary"
          @click="handleSaveClass('classForm')"
          >{{ $t('save') }}</el-button
        >
        <el-button @click="handleCloseClass">
          {{ $t('cancel') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 新增/编辑属性弹窗 -->
    <el-dialog
      :title="attributeTitle"
      :visible.sync="attributeDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      class="large-dialog"
      v-dialogDrag
      @close="attributeFormClose"
    >
      <el-form
        label-width="150px"
        ref="attributeForm"
        :rules="currentLang === 'zh-Hans' ? attributeFormRules : attributeFormEnRules"
        :model="attributeForm"
        label-position="right"
        style="height: 100%; overflow-y: auto; overflow-x: hidden"
      >
        <el-row :gutter="20" style="box-sizing: border-box">
          <el-col :span="12">
            <el-form-item :label="`${$t('seqNo')}`" prop="seqNo">
              <el-input-number
                :disabled="attributeTitle === $t('attributeDetail')"
                v-model="attributeForm.seqNo"
                :controls="false"
                size="small"
                class="w-440px"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label prop="isPrimary">
              <el-checkbox
                :disabled="
                  attributeTitle === $t('attributeDetail') || attributeTitle === $t('editAttribute')
                "
                :label="`${$t('isPrimary')}`"
                v-model="attributeForm.isPrimary"
              ></el-checkbox>
              <!-- <el-checkbox
                :disabled="
                  attributeTitle === $t('attributeDetail') || attributeTitle === $t('editAttribute')
                "
                :label="`${$t('nameAttribute')}`"
                v-model="attributeForm.isName"
              ></el-checkbox>
              <el-checkbox
                :disabled="
                  attributeTitle === $t('attributeDetail') || attributeTitle === $t('editAttribute')
                "
                :label="`${$t('tagAttribute')}`"
                v-model="attributeForm.isTag"
              ></el-checkbox> -->
              <el-checkbox
                :disabled="
                  attributeTitle === $t('attributeDetail') || attributeTitle === $t('editAttribute')
                "
                :label="`${$t('isNull')}`"
                v-model="attributeForm.isNullable"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 属性类型是引用类型，引用属性必填，引用显示属性非必填 -->
            <el-form-item
              :label="`${$t('referenceAttribute')}`"
              prop="referenceClassAttributeId"
              :rules="attributeForm.valueType === 10 ? referenceAttributeRules : {}"
            >
              <el-input
                v-model="attributeForm.referenceClassAttributeName"
                :placeholder="`${$t('pleaseSelect')}`"
                clearable
                class="w-full can-not-input"
                @clear="clearReferenceAttribute"
                :disabled="
                  attributeForm.isPrimary ||
                    attributeTitle === $t('attributeDetail') ||
                    attributeTitle === $t('editAttribute')
                "
              >
                <el-button
                  slot="append"
                  icon="iconfont icon-line-seach"
                  @click="showRefenenceDialog = true"
                  :disabled="
                    attributeForm.isPrimary ||
                      attributeTitle === $t('attributeDetail') ||
                      attributeTitle === $t('editAttribute')
                  "
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="`${$t('displayReferenceClassAttributeId')}`"
              prop="displayReferenceClassAttributeId"
            >
              <el-select
                size="small"
                filterable
                multiple
                :disabled="
                  !attributeForm.referenceClassAttributeId ||
                    attributeTitle === $t('attributeDetail')
                "
                v-model="attributeForm.displayReferenceClassAttributeId"
                clearable
                :placeholder="`${$t('pleaseSelect')}`"
                class="w-full"
              >
                <el-option
                  v-for="item in displayReferenceClassAttributeArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                  <span class="l m-r-10">{{ item.className }}</span>
                  <span class="text-color-grey-ccc fz-14 r">{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="`${$t('standardAttribute')}`" prop="attributeName">
              <el-input
                v-model="attributeForm.attributeName"
                :placeholder="`${$t('pleaseSelect')}`"
                clearable
                class="w-full can-not-input"
                @clear="clearStandardAttribute"
                :disabled="
                  bzsxDisabled ||
                    attributeTitle === $t('attributeDetail') ||
                    attributeTitle === $t('editAttribute')
                "
              >
                <el-button
                  slot="append"
                  icon="iconfont icon-line-seach"
                  @click="showAttributeDialog = true"
                  :disabled="
                    bzsxDisabled ||
                      attributeTitle === $t('attributeDetail') ||
                      attributeTitle === $t('editAttribute')
                  "
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="`${$t('attributeCode')}`" prop="code">
              <el-input
                :disabled="
                  attributeTitle === $t('attributeDetail') || attributeTitle === $t('editAttribute')
                "
                size="small"
                v-model="attributeForm.code"
                clearable
                class="w-full"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="`${$t('name')}`" prop="name">
              <el-input
                size="small"
                :readonly="attributeTitle === $t('attributeDetail')"
                clearable
                v-model="attributeForm.name"
                class="w-full"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 属性类型 -->
          <el-col :span="12">
            <el-form-item :label="`${$t('attributeType')}`" prop="valueType">
              <el-select
                v-model="attributeForm.valueType"
                filterable
                clearable
                :placeholder="`${$t('pleaseSelect')}`"
                class="w-full"
                size="small"
                disabled
              >
                <el-option
                  v-for="item in valueTypeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 属性类型为【布尔，日期时间，日期，时间】时，长度禁止编辑且固定长度 -->
          <el-col :span="12">
            <el-form-item :label="`${$t('length')}`" prop="length">
              <el-input-number
                v-model="attributeForm.length"
                :controls="false"
                :disabled="
                  attributeTitle === $t('attributeDetail') ||
                    _.includes([4, 6, 8, 9], attributeForm.valueType)
                "
                size="small"
                class="w-440px"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="`${$t('decimalPoint')}`" prop="decimalPoint">
              <el-input-number
                :disabled="
                  attributeForm.valueType !== 3 ||
                    attributeTitle === $t('attributeDetail') ||
                    attributeTitle === $t('editAttribute')
                "
                v-model="attributeForm.decimalPoint"
                :controls="false"
                size="small"
                class="w-440px"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="`${$t('defaultValue')}`" prop="defaultValue">
              <el-input
                class="w-full"
                size="small"
                v-model="attributeForm.defaultValue"
                @blur="checkDefaultValue"
                :disabled="attributeTitle === $t('attributeDetail')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="属性分组:"
              prop="classAttributeGroupId">
              <el-select size="small"
                filterable
                v-model="attributeForm.classAttributeGroupId"
                clearable
                placeholder="请选择"
                class="w-full">
                <el-option v-for="item in attributeGroupList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :span="12">
            <!-- <el-form-item :label="`${$t('columnName')}`" prop="columnName">
              <el-input
                :readonly="
                  attributeTitle === $t('attributeDetail') || attributeTitle === $t('editAttribute')
                "
                v-model="attributeForm.columnName"
                clearable
                disabled
                size="small"
                class="w-full"
              ></el-input>
            </el-form-item> -->
          </el-col>
          <el-col :span="12">
            <!-- 数据类型未布尔时，不可选择单位 -->
            <el-form-item :label="`${$t('unit')}`" prop="unitId">
              <el-select
                :disabled="
                  attributeTitle === $t('attributeDetail') || attributeForm.valueType === 4
                "
                v-model="attributeForm.unitId"
                clearable
                filterable
                :placeholder="`${$t('pleaseSelect')}`"
                class="w-full"
                size="small"
              >
                <el-option
                  v-for="item in unitList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                  <span style="float: left">{{ item.unitTypeName }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="`${$t('relationIdentify')}`" prop="identifierIdArr">
              <el-select
                size="small"
                clearable
                filterable
                v-model="attributeForm.identifierIdArr"
                :placeholder="`${$t('pleaseSelect')}`"
                class="w-full"
                :disabled="attributeTitle === $t('attributeDetail')"
                multiple
              >
                <el-option
                  v-for="item in attrRelationLabelList"
                  :key="item.id"
                  :label="`${item.groupName}(${item.code}-${item.name})`"
                  :value="item.id"
                >
                  <span class="l m-r-10">{{ item.groupName }}</span>
                  <span class="text-color-grey-ccc fz-14 r">{{ item.code }}-{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 数据脱敏规则 -->
          <el-col :span="12">
            <el-form-item
              :label="`${$t('dataDesensitizationRule')}`"
              prop="dataDesensitizationRuleId"
            >
              <el-select
                size="small"
                clearable
                filterable
                v-model="attributeForm.dataDesensitizationRuleId"
                :placeholder="`${$t('pleaseSelect')}`"
                class="w-full"
                :disabled="attributeTitle === $t('attributeDetail')"
              >
                <el-option
                  v-for="item in desensitizationList"
                  :key="item.id"
                  :label="item.ruleName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 参考数据 -->
          <!-- 属性类型是布尔类型时，参考数据禁用；属性类型是Enum类型或枚举-多选时，参考数据必填；其他类型参考数据不可编辑 -->
          <el-col :span="12">
            <el-form-item
              :label="`${$t('referenceData')}`"
              prop="referenceDataClassId"
              :rules="_.includes([5, 7], attributeForm.valueType) ? referenceDataRules : {}"
            >
              <el-select
                size="small"
                clearable
                filterable
                v-model="attributeForm.referenceDataClassId"
                :placeholder="`${$t('pleaseSelect')}`"
                class="w-full"
                :disabled="
                  attributeTitle === $t('attributeDetail') ||
                    !_.includes([5, 7], attributeForm.valueType)
                "
              >
                <el-option
                  v-for="item in referenceDataList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="`${$t('ruleExpression')}`" prop="ruleExpression">
              <el-input
                :disabled="attributeTitle === $t('attributeDetail')"
                size="small"
                :placeholder="$t('enterRuleExpression')"
                v-model="attributeForm.ruleExpression"
                @blur="checkRuleExpression"
                clearable
                class="!w-full"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('extendedProperties')">
              <el-switch
                v-model="attributeForm.isExtend"
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="0"
                @change="isExtendChange"
                :disabled="attributeTitle === $t('attributeDetail')"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('extendPropertyValue')" v-if="attributeForm.isExtend">
              <el-input
                v-model="attributeForm.referenceClassAttributeName"
                :placeholder="`${$t('pleaseSelect')}`"
                class="!w-full can-not-input input-extendProperty"
                @clear="clearReferenceAttribute"
                :disabled="attributeTitle === $t('attributeDetail')"
              >
                <template slot="prefix">
                  <div v-if="extendClassList.length > 0">
                    <el-tag
                      v-for="(item, index) in extendClassList"
                      :key="item.id"
                      class="mr-5px mt-5px"
                      slot="prepend"
                      type="info"
                      size="small"
                      @close="removeExtendClass(item, index)"
                      closable
                      >{{ item.stdClassExtendAttributeDtos[0].displayName }}</el-tag
                    >
                  </div>
                </template>
                <div slot="append" class="h-full flex !w-100px">
                  <el-button
                    icon="iconfont icon-line-seach"
                    @click="extendedPropertiesDialog = true"
                    :disabled="attributeTitle === $t('attributeDetail')"
                  ></el-button>
                  <div class="w-1px h-full bg-[#DCDEE2]"></div>
                  <el-button
                    :disabled="attributeTitle === $t('attributeDetail')"
                    icon="el-icon-upload2"
                    @click="handleUpload"
                  >
                  </el-button>
                </div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('readAndQritePermissions')">
              <el-checkbox
                :disabled="attributeTitle === $t('attributeDetail')"
                :label="$t('import')"
                v-model="attributeForm.allowImport"
              ></el-checkbox>
              <el-checkbox
                :disabled="attributeTitle === $t('attributeDetail')"
                :label="$t('export')"
                v-model="attributeForm.allowExport"
              ></el-checkbox>
              <el-checkbox
                :disabled="attributeTitle === $t('attributeDetail')"
                :label="$t('edit')"
                v-model="attributeForm.allowUpdate"
              ></el-checkbox>
              <el-checkbox
                :disabled="attributeTitle === $t('attributeDetail')"
                :label="$t('APIInputField')"
                v-model="attributeForm.isQuery"
              ></el-checkbox>
              <el-checkbox
                :disabled="attributeTitle === $t('attributeDetail')"
                :label="$t('queryDataIsNotDisplayed')"
                v-model="attributeForm.isDisplay"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <div v-if="attributeTitle === $t('createAttribute')">
            <el-col :span="12" v-for="(item, index) in actionAttrList" :key="index">
              <el-form-item :label="$t(item.actualAttributeColumnName)" prop="value" class="w-full">
                <el-input
                  size="small"
                  :readonly="attributeTitle === $t('attributeDetail')"
                  clearable
                  v-model="item.value"
                  v-if="item.valueType === 1"
                ></el-input>
                <el-select
                  size="small"
                  :disabled="attributeTitle === $t('attributeDetail')"
                  clearable
                  v-model="item.value"
                  v-if="item.valueType === 5"
                  filterable
                  :placeholder="`${$t('pleaseSelect')}`"
                  class="w-full"
                >
                  <el-option
                    v-for="it in item.actionArr"
                    :key="it.id"
                    :label="it.name"
                    :value="it.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </div>
          <div v-else>
            <el-col
              :span="12"
              v-for="(item, index) in attributeForm.dynamicColumnData"
              :key="index"
            >
              <el-form-item :label="$t(item.actualAttributeColumnName)" prop="value" class="w-full">
                <el-input
                  :readonly="attributeTitle === $t('attributeDetail')"
                  size="small"
                  clearable
                  v-model="item.value"
                  v-if="item.valueType === 1"
                ></el-input>
                <el-select
                  size="small"
                  clearable
                  :disabled="attributeTitle === $t('attributeDetail')"
                  filterable
                  v-model="item.value"
                  v-if="item.valueType === 5"
                  :placeholder="`${$t('pleaseSelect')}`"
                  class="w-full"
                >
                  <el-option
                    v-for="it in item.actionArr"
                    :key="it.id"
                    :label="it.name"
                    :value="it.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </div>
          <el-col :span="12" v-for="(item, index) in personalityMetaData" :key="index">
            <!-- 字符串，整数，小数 -->
            <el-form-item
              v-if="['1', '2', '3'].includes(item.dataType)"
              :label="item.name"
              class="w-full"
            >
              <el-input
                type="text"
                size="small"
                v-model.trim="item.dataValue"
                :max-length="item.dataType === '1' ? item.length : ''"
                :disabled="attributeTitle === $t('attributeDetail')"
                @input="metaDataInputChange($event, item.dataType, item)"
                clearable
              ></el-input>
            </el-form-item>
            <!-- 布尔 -->
            <el-form-item v-if="item.dataType === '4'" :label="item.name" class="w-full">
              <el-radio-group
                v-model="item.dataValue"
                :disabled="attributeTitle === $t('attributeDetail')"
              >
                <el-radio label="true">{{ $t('yes') }}</el-radio>
                <el-radio label="false">{{ $t('no') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 日期时间 -->
            <el-form-item v-if="item.dataType === '5'" :label="item.name" class="w-full">
              <el-date-picker
                v-model="item.dataValue"
                type="datetime"
                class="!w-full"
                :disabled="attributeTitle === $t('attributeDetail')"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" v-if="attributeTitle !== $t('attributeDetail')" class="dialog-footer tc">
        <el-button
          type="primary"
          :disabled="disabledAttrBtn"
          @click="attributeFormSave('attributeForm')"
          >{{ $t('save') }}</el-button
        >
        <el-button @click="attributeFormClose">
          {{ $t('cancel') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 类别变更记录详情 -->
    <el-dialog
      :title="`${$t('changeDetail')}`"
      :visible.sync="isShowDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      class="small-dialog"
      v-dialogDrag
    >
      <div class="dialog w-full h-full">
        <el-row :gutter="10" class="mb-10px">
          <el-col :span="8"
            >{{ `${$t('changeType')}` }}：{{ changeLogDetail.changeTypeName }}</el-col
          >
          <el-col :span="8"
            >{{ `${$t('changeUser')}` }}：{{ changeLogDetail.createdUserName }}</el-col
          >
          <el-col :span="8"
            >{{ `${$t('changeTime')}` }}：{{ changeLogDetail.lastModifiedTime }}</el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="clearfix tc">
                <span>{{ `${$t('changeBefore')}` }}</span>
              </div>
              <div
                v-for="(value, key, index) in changeLogDetail.dicBeforeValue"
                :key="index"
                class="text item ml-30px"
              >
                {{ key }}: {{ value }}
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="clearfix tc">
                <span>{{ `${$t('changeAfter')}` }}</span>
              </div>
              <div
                v-for="(value, key, index) in changeLogDetail.dicAfterValue"
                :key="index"
                class="text item ml-30px"
              >
                {{ key }}: {{ value }}
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer tc">
        <el-button @click="isShowDialog = false">{{ $t('close') }}</el-button>
      </div>
    </el-dialog>

    <wiz-upload-file
      v-dialogDrag
      @refreshList="searchClass"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>

    <!-- 引用属性搜索对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="showRefenenceDialog"
      :title="$t('referenceAttribute')"
      v-dialogDrag
    >
      <refenenceSearch
        v-if="showRefenenceDialog"
        :single="true"
        @selectReferenceClassAttributeId="selectReferenceClassAttributeId"
        :standardId="standardId"
        type="entity"
      />
    </el-dialog>
    <!-- 标准属性搜索对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="showAttributeDialog"
      :title="$t('standardAttribute')"
      v-dialogDrag
    >
      <attributeSearch
        v-if="showAttributeDialog"
        :single="true"
        @selectAttributeId="selectAttributeId"
        :standardId="standardId"
      />
    </el-dialog>
    <!-- 扩展属性弹框 -->
    <extendedPropertiesSearch
      v-if="extendedPropertiesDialog"
      :single="false"
      :standardId="standardId"
      :currentRow="currentRow"
      type="entity"
      :extendedPropertiesDialog="extendedPropertiesDialog"
      :originExtendClassList="extendClassList"
      @saveExtendClassList="saveExtendClassList"
      @closeDialog="closeExtendedPropertiesDialog"
    />
    <!-- 新增属性分组弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="attrGropsDialogVisible"
      :title="attrGroupsTitle"
      v-dialogDrag
      width="480px"
    >
      <el-form
        label-width="80px"
        ref="attrGropsForm"
        :rules="attrGropsFormRules"
        :model="attrGropsForm"
      >
        <el-form-item :label="$t('seqNo')" prop="seqNo" class="w-full">
          <el-input-number
            class="w-full"
            size="small"
            v-model.trim="attrGropsForm.seqNo"
            controls-position="right"
            :min="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('name')" prop="name" class="w-full">
          <el-input size="small" v-model.trim="attrGropsForm.name" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer tc">
        <el-button
          type="primary"
          @click="attrGropsFormSave()"
          :loading="attrGropsFormSaveLoading"
          >{{ $t('save') }}</el-button
        >
        <el-button @click="attrGropsDialogVisible = false"> {{ $t('cancel') }} </el-button>
      </div>
    </el-dialog>
    <!-- 分组弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="divideGroupDialogVisible"
      :title="$t('selectTheGroup')"
      v-dialogDrag
      width="420px"
    >
      <div class="mb-20px">
        <el-input
          size="small"
          class="mr-10px w-200px"
          v-model.trim="attrKeyword"
          :placeholder="$t('pleaseEnter')"
          clearable
        ></el-input>
        <el-button type="primary" @click="getAttributeGroupList">{{ $t('search') }}</el-button>
      </div>
      <el-radio-group class="divide-group_radio" v-model="divideGroupSelected">
        <el-radio
          class="mb-10px"
          v-for="item in selectGroupList"
          :key="item.id"
          :label="item.name"
          @click.native.prevent="radioClick(item)"
          >{{ item.name }}</el-radio
        >
      </el-radio-group>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="operateGroup()" :loading="attrGropsFormSaveLoading">{{
          $t('save')
        }}</el-button>
        <el-button @click="divideGroupDialogVisible = false"> {{ $t('cancel') }} </el-button>
      </div>
    </el-dialog>
    <!-- 影响分析弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="showEffectAnalysisDialog"
      :title="analysisTitle"
      width="1200px"
      v-dialogDrag
    >
      <effectAnalysis
        v-if="showEffectAnalysisDialog"
        class="!h-640px"
        :analysisType="analysisType"
        :seriesData="effectAnalysisData"
      />
    </el-dialog>
    <upload-extended-attribute
      v-if="showUploadExtendedAttribute"
      :visible.sync="showUploadExtendedAttribute"
      :attributeId="attributeForm.id"
      @confirm="saveExtendClassList"
    >
    </upload-extended-attribute>
  </div>
</template>

<script>
import CommonService from '@/services/Common'
import MasterDataManageService from '@/services/masterDataManageService'
import ReferenceDataService from '@/services/ReferenceDataService'
import DesensitizationService from '@/services/Desensitization'
import stdClassListService from '@/services/stdClassListService'
import StdIdentifierService from '@/services/bsApi/StdIdentifierService'
// import StdClassAttributeGroupService from '@/services/StdClassAttributeGroupService'
import StdSubjectDomainService from '@/services/bsApi/StdSubjectDomainService'
import StdClassTreeService from '@/services/bsApi/StdClassTreeService'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
import StdClassTypeService from '@/services/bsApi/StdClassTypeService'
import EntityTypeService from '@/services/EntityTypeService'
import stdClassLabelService from '@/services/stdClassLabelService'
import ColumnVisible from '@/components/ColumnVisible'
import StdClassAttributeService from '@/services/bsApi/StdClassAttributeService'
import unitMeasureservice from '@/services/unitMeasureservice'
import StdChangeRecordService from '@/services/bsApi/StdChangeRecordService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'
import refenenceSearch from './components/refenenceSearch'
import attributeSearch from './components/attributeSearch'
import extendedPropertiesSearch from './components/extendedPropertiesSearch'
import effectAnalysis from './components/effectAnalysis'
import uploadExtendedAttribute from './components/uploadExtendedAttribute'

const squareProgress = () => {
  return import('@/components/squareProgress')
}

export default {
  components: {
    ColumnVisible,
    selectStandardId,
    refenenceSearch,
    attributeSearch,
    extendedPropertiesSearch,
    effectAnalysis,
    uploadExtendedAttribute,
    squareProgress,
  },
  mixins: [fnMixin],
  data() {
    return {
      getProgress: false,
      currentProgress: 0, // 当前进度
      publishProgressTimer: null,
      showUploadExtendedAttribute: false,
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      totalClassSlection: [], // 所有类别的勾选
      currentClassRowId: '',
      showRigth: true,
      showLeft: true,
      // 变更记录详情部分
      showClassChange: false,
      changeLogList: [],
      isShowDialog: false,
      changeLogDetail: {},
      changeLoading: false,
      //  标准部分
      standardId: '',
      standardCode: localStorage.getItem('standardCode'),
      // 类别部分
      selectedClassList: [],
      classListLoading: true,
      saveClassLoading: false,
      selectedClassId: '',
      classKeyword: '',
      classTypeId: '', // 类别类型
      entityTypeId: '', // 实体类型
      tableClassData: [],
      tableClassFilterHeader: [
        {
          value: 'code',
          label: 'classCode',
        },
        {
          value: 'name',
          label: 'className',
        },
        {
          value: 'stdClassTypeAttributeCateName',
          label: this.$t('类型'),
          width: '80',
        },
        {
          value: 'isType',
          label: this.$t('whetherItIisAtypeOrNot'),
          width: '120',
        },
      ],
      tableClassHeader: [
        {
          value: 'seqNo',
          label: 'seqNo',
        },
        {
          value: 'code',
          label: 'classCode',
        },
        {
          value: 'name',
          label: 'className',
        },
        {
          value: 'classTypeName',
          label: this.$t('classType'),
        },
        {
          value: 'stdClassTypeAttributeCateName',
          label: this.$t('类型'),
          width: '80',
        },
        {
          value: 'isType',
          label: this.$t('whetherItIisAtypeOrNot'),
          width: '120',
        },
      ],
      pageNoClass: 1,
      pageSizeClass: 15,
      recordCountClass: 0,
      columnVisibleOptionsClass: [
        {
          value: 'seqNo',
          label: this.$t('seqNo'),
        },
        {
          value: 'code',
          label: this.$t('classCode'),
        },
        {
          value: 'name',
          label: this.$t('className'),
        },
        {
          value: 'classTypeName',
          label: this.$t('classType'),
        },
        {
          value: 'stdClassTypeAttributeCateName',
          label: this.$t('类型'),
        },
        {
          value: 'isType',
          label: this.$t('whetherItIisAtypeOrNot'),
        },
        {
          value: 'tableName',
          label: this.$t('tableName'),
        },
        {
          value: 'description',
          label: this.$t('description'),
        },
        {
          value: 'remark',
          label: this.$t('remark'),
        },
      ],
      columnVisibleClass: [
        'code',
        'name',
        // 'parentId',
        'parentName',
        // 'classTypeName',
        'stdClassTypeAttributeCateName',
        // 'classTypeId',
        'isType',
        'tableName',
        'description',
        'remark',
      ],
      classTitle: this.$t('createClass'),
      classDialog: false,
      classFormRules: {
        code: [
          { required: true, message: this.$t('pleaseEnterCode'), trigger: 'blur' },
          {
            pattern: /^[^\\/?*\[\]".-]*$/, // 类别代码不包含\ / ? * [ ] " " . - 字符
            message: this.$t('pleaseEnterMathesRule'),
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: this.$t('PleaseEnterAName'), trigger: 'blur' }],
        // parentId: [{ required: true, message: '请选择上级类别', trigger: 'change' }],
        // seqNo: [{ required: true, message: '请输入序号', trigger: 'blur' }],
        infoType: [{ required: true, message: this.$t('pleaseEnterInfoType'), trigger: 'blur' }],
        isMainData: [{ required: false, message: this.$t('whetherMainData'), trigger: 'change' }],
        isType: [{ required: true, message: this.$t('selectWhetherType'), trigger: 'change' }],
      },
      classFormEnRules: {
        code: [
          { required: true, message: this.$t('pleaseEnterCode'), trigger: 'blur' },
          {
            required: true,
            pattern: /^[^\\/?*\[\]".-]*$/, // 类别代码不包含\ / ? * [ ] " " . - 字符
            message: this.$t('pleaseEnterMathesRule'),
            trigger: 'change',
          },
        ],
        name: [{ required: true, message: this.$t('pleaseEnterTheName'), trigger: 'blur' }],
        infoType: [{ required: true, message: this.$t('pleaseEnterInfoType'), trigger: 'blur' }],
      },
      classForm: {
        dynamicColumnData: [],
      },
      parentTypeList: [],
      typeClassList: [],
      classTypeAttributeList: [],
      classLabelList: [],
      classRelationLabelList: [],
      actionClassList: [],
      classStatus: null,
      flag: true,
      // 属性部分
      attrListLoading: false,
      disabledAttrBtn: false,
      attrKeyword: '',
      tableAttrData: [],
      pageNoAttr: 1,
      pageSizeAttr: 15,
      recordCountAttr: 0,
      tableAttrFilterHeader: [
        {
          value: 'seqNo',
          label: 'seqNo',
          isCheckBox: false,
          width: 80,
        },
        {
          value: 'code',
          label: 'attributeCode',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'name',
          label: 'attributeName',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'name',
          label: '标准属性',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'refSourceAttributeName',
          label: 'referenceAttribute',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'isPrimary',
          label: 'isPrimary',
          isCheckBox: true,
          width: 110,
        },
        {
          value: 'isNullable',
          label: 'isNull',
          isCheckBox: true,
        },
        {
          value: 'valueTypeName',
          label: 'attributeType',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'length',
          label: 'length',
          isCheckBox: false,
        },
        {
          value: 'unitName',
          label: 'unit',
          isCheckBox: false,
        },
      ],
      tableAttrHeader: [
        {
          value: 'seqNo',
          label: 'seqNo',
          isCheckBox: false,
          width: 80,
        },
        {
          value: 'code',
          label: 'attributeCode',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'name',
          label: 'attributeName',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'name',
          label: '标准属性',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'valueTypeName',
          label: 'attributeType',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'isPrimary',
          label: 'isPrimary',
          isCheckBox: true,
          width: 110,
        },
        {
          value: 'isName',
          label: 'nameAttribute',
          isCheckBox: true,
          width: 110,
        },
        {
          value: 'isTag',
          label: 'tagAttribute',
          isCheckBox: true,
          width: 120,
        },
        {
          value: 'allowImport',
          label: this.$t('import'),
          isCheckBox: true,
          width: 120,
        },
        {
          value: 'allowExport',
          label: this.$t('export'),
          isCheckBox: true,
          width: 120,
        },
        {
          value: 'allowUpdate',
          label: this.$t('edit'),
          isCheckBox: true,
          width: 120,
        },
        {
          value: 'isQuery',
          label: this.$t('APIInputField'),
          isCheckBox: true,
          width: 120,
        },
        {
          value: 'isNullable',
          label: 'isNull',
          isCheckBox: true,
        },
        {
          value: 'refSourceAttributeName',
          label: 'referenceAttribute',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'length',
          label: 'length',
          isCheckBox: false,
        },
        {
          value: 'decimalPoint',
          label: 'decimalPoint',
          isCheckBox: false,
        },
        {
          value: 'defaultValue',
          label: 'defaultValue',
          isCheckBox: false,
        },
        {
          value: 'columnName',
          label: 'columnName',
          isCheckBox: false,
        },
        {
          value: 'attributeGroupName',
          label: this.$t('attributeGrouping'),
          isCheckBox: false,
        },
        {
          value: 'unitName',
          label: 'unit',
          isCheckBox: false,
        },
        {
          value: 'ruleExpression',
          label: 'ruleExpression',
          isCheckBox: false,
        },
      ],
      tableGroupHeader: [
        {
          value: 'seqNo',
          label: 'seqNo',
          isCheckBox: false,
          width: 80,
        },
        {
          value: 'attributeGroupName',
          label: '属性分组',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'code',
          label: 'attributeCode',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'name',
          label: 'attributeName',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'name',
          label: '标准属性',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'refSourceAttributeName',
          label: 'referenceAttribute',
          isCheckBox: false,
          width: 110,
        },
        {
          value: 'isPrimary',
          label: 'isPrimary',
          isCheckBox: true,
          width: 110,
        },
      ],
      columnVisibleOptionsAttr: [
        {
          value: 'seqNo',
          label: 'seqNo',
          isCheckBox: false,
          // width: 80,
        },
        {
          value: 'code',
          label: 'attributeCode',
          isCheckBox: false,
        },
        {
          value: 'name',
          label: 'attributeName',
          isCheckBox: false,
        },
        {
          value: 'valueTypeName',
          label: 'attributeType',
          isCheckBox: false,
        },
        {
          value: 'isPrimary',
          label: 'isPrimary',
          isCheckBox: true,
          width: 120,
        },
        {
          value: 'isName',
          label: 'nameAttribute',
          isCheckBox: true,
          width: 120,
        },
        {
          value: 'isTag',
          label: 'tagAttribute',
          isCheckBox: true,
          width: 120,
        },
        {
          value: 'allowImport',
          label: this.$t('import'),
          isCheckBox: true,
          width: 120,
        },
        {
          value: 'allowExport',
          label: this.$t('export'),
          isCheckBox: true,
          width: 120,
        },
        {
          value: 'allowUpdate',
          label: this.$t('edit'),
          isCheckBox: true,
          width: 120,
        },
        {
          value: 'isQuery',
          label: this.$t('APIInputField'),
          isCheckBox: true,
          width: 120,
        },
        {
          value: 'isNullable',
          label: 'isNull',
          isCheckBox: true,
        },
        {
          value: 'refSourceAttributeName',
          label: 'referenceAttribute',
          isCheckBox: false,
        },
        {
          value: 'length',
          label: 'length',
          isCheckBox: false,
        },
        {
          value: 'decimalPoint',
          label: 'decimalPoint',
          isCheckBox: false,
        },
        {
          value: 'defaultValue',
          label: 'defaultValue',
          isCheckBox: false,
        },
        {
          value: 'columnName',
          label: 'columnName',
          isCheckBox: false,
        },
        {
          value: 'unitName',
          label: 'unit',
          isCheckBox: false,
        },
        {
          value: 'ruleExpression',
          label: 'ruleExpression',
          isCheckBox: false,
        },
      ],
      columnVisibleAttr: ['seqNo', 'code', 'name', 'valueType', 'isPrimary'],
      actionAttrList: [],
      attributeTitle: '',
      attributeDialog: false,
      attributeFormEnRules: {
        seqNo: [
          {
            required: false,
            pattern: /^\+?[0-9]\d*$/,
            message: this.$t('onlyEnterNumbersGreaterThanEqual0'),
            trigger: 'change',
          },
        ],
        code: [
          { required: true, message: this.$t('pleaseEnterCode'), trigger: 'change' },
          {
            required: true,
            pattern: /^[\u0001-\u007F,\u0080-\uFFFF]+$/,
            message: this.$t('pleaseEnterMathesRule'),
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: this.$t('pleaseEnterTheName'), trigger: 'blur' }],
        valueType: [{ required: true, message: this.$t('pleaseSelect'), trigger: 'blur' }],
        attributeName: [{ required: true, message: this.$t('pleaseSelect'), trigger: 'blur' }],
        length: [
          {
            required: false,
            pattern: /^\+?[0-9]\d*$/,
            message: this.$t('onlyEnterNumbersGreaterThanEqual0'),
            trigger: 'change',
          },
        ],
      },
      attributeFormRules: {
        seqNo: [
          {
            required: false,
            pattern: /^\+?[0-9]\d*$/,
            message: this.$t('onlyEnterNumbersGreaterThanEqual0'),
            trigger: 'change',
          },
        ],
        code: [
          { required: true, message: this.$t('pleaseEnterCode'), trigger: 'change' },
          {
            required: true,
            pattern: /^[\u0001-\u007F,\u0080-\uFFFF]+$/,
            message: this.$t('pleaseEnterMathesRule'),
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: this.$t('PleaseEnterAName'), trigger: 'blur' }],
        valueType: [{ required: true, message: this.$t('pleaseSelect'), trigger: 'blur' }],
        attributeName: [{ required: true, message: this.$t('pleaseSelect'), trigger: 'blur' }],
        length: [
          {
            required: false,
            pattern: /^\+?[0-9]\d*$/,
            message: this.$t('onlyEnterNumbersGreaterThanEqual0'),
            trigger: 'change',
          },
        ],
      },
      attributeForm: {
        dynamicColumnData: [],
      },
      displayReferenceClassAttributeArr: [],
      valueTypeList: [],
      quoteList: [],
      attributeGroupList: [],
      attrRelationLabelList: [],
      unitList: [],
      tableAttribType: 1,
      multipleSelectionId: [],
      standardAttrList: [],
      quoteDisabled: false,
      bzsxDisabled: false,
      viewStorageTitle: '',
      storageHeader: [
        {
          value: 'seqNo',
          label: 'seqNo',
          isCheckBox: false,
          width: 80,
        },
        {
          value: 'name',
          label: 'attributeName',
          isCheckBox: false,
        },
        {
          value: 'code',
          label: 'attributeCode',
          isCheckBox: false,
        },
        {
          value: 'columnName',
          label: 'fieldName',
          isCheckBox: false,
        },
        {
          value: 'valueTypeName',
          label: 'attributeType',
          isCheckBox: false,
        },
        {
          value: 'length',
          label: 'length',
          isCheckBox: false,
          width: 80,
        },
        {
          value: 'decimalPoint',
          label: 'decimalPoint',
          isCheckBox: false,
          width: 80,
        },
        {
          value: 'defaultValue',
          label: 'defaultValue',
          isCheckBox: false,
        },
      ],
      tableStorageData: [],
      pageNoStorage: 1,
      pageSizeStorage: 15,
      recordCountStorage: 0,
      storageLoading: false,
      selectStorageId: '',
      currentRow: {},
      desensitizationList: [],
      referenceDataList: [],
      referenceDataRules: [{ required: true, message: '请选择参考数据', trigger: 'blur' }],
      referenceAttributeRules: [{ required: true, message: '请选择引用属性', trigger: 'blur' }],
      dataMainTypeIdRules: [{ required: true, message: '请选择主数据类型', trigger: 'blur' }],
      mainDataTypeList: [], // 主数据类型列表
      publishLoading: false,
      publishOneLoading: false,
      maps: new Map(),
      currentStorage: {}, // 当前存储设置页面展示的实体信息
      unpublishLoading: false,
      showRefenenceDialog: false, // 显示引用属性搜索弹窗
      showAttributeDialog: false, // 显示标准属性搜索弹窗
      attrGroups: [
        // { name: '位号', value: '0' },
        // { name: '通用属性', value: '1' },
        // { name: '设计属性', value: '2' },
        // { name: '采购属性', value: '3' },
      ],
      selectedGroup: [],
      currentSelectedGroup: null,
      attrGroupsTitle: '',
      attrGropsDialogVisible: false,
      attrGropsFormSaveLoading: false,
      attrGropsForm: {
        seqNo: '',
        name: '',
      },
      attrGropsFormRules: {
        seqNo: [{ required: true, message: '请输入序号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      },
      divideGroupDialogVisible: false,
      divideGroupSelected: '',
      currentDivideGroup: null,
      groupClassDisabled: false, // 分组属性是否能编辑
      selectGroupList: [],
      noGroupList: [], // 未分组
      currentAttribute: {},
      arrtibuteSelect: [],
      classList: [],
      extendClassList: [],
      extendedPropertiesDialog: false,
      themeList: [],
      isPublished: false,
      personalityMetaData: [], // 实体个性化元数据
      attrPersonalityMetaData: [], // 属性个性化元数据
      classPros: {
        label: 'code',
        children: 'children',
        isLeaf: (data) => {
          if (!data.isLeaf) {
            return true
          }
          return false
        },
      },
      isShowTreeMode: true,
      attrActiveName: 'attribute',
      attrGroupProps: {
        label: 'name',
        children: 'children',
      },
      selectStandardProps: {
        width: 'w-150px',
      },
      isShowTooltip: false,
      analysisTitle: '',
      analysisType: '',
      showEffectAnalysisDialog: false,
      effectLoading: false,
      effectAnalysisData: [],
      bloodLoading: false,
      changeTypeList: [
        { label: '类别变更', value: '1' },
        { label: '属性变更', value: '2' },
        { label: '属性值变更', value: '3' },
      ],
      changelogSearchForm: {
        changeType: '',
        keyord: '',
      },
      changeLogPage: {
        pageNo: 1,
        pageSize: 15,
        count: 0,
      },
    }
  },
  computed: {
    selectPublishCalss() {
      const publishClass = _.filter(this.totalClassSlection, { approveStatus: 1 })
      return !_.isEmpty(publishClass)
    },
    currentLang() {
      return this.$store.getters['System/currentLang']
    },
  },
  async created() {
    if (this.$route.query.id) {
      this.standardId = this.$route.query.id
    }
    const standardId = localStorage.getItem('standardId')
    if (standardId) {
      this.standardId = standardId
    }
  },
  beforeDestroy() {
    this.publishProgressTimer = null
    clearInterval(this.publishProgressTimer)
  },
  // activated() {
  //   const standardId = localStorage.getItem('standardId')
  //   if (standardId) {
  //     this.standardId = standardId
  //   }
  //   // this.standardId = localStorage.getItem('standardId')
  // },
  mounted() {
    const _this = this
    window.onresize = function() {
      _this.$nextTick(() => {
        if (_this.$refs.classTable) {
          _this.$refs.classTable.doLayout()
        }
        if (_this.$refs.attrTable) {
          _this.$refs.attrTable.doLayout()
        }
      })
    }
  },
  watch: {
    currentSelectedGroup: {
      handler(newVal) {
        if (newVal) {
          if (newVal.name === '未分组') {
            this.tableAttrData = this.noGroupList
          } else {
            this.getAttrList()
          }
        } else {
          this.getAttrList()
        }
      },
    },
    totalClassSlection: {
      handler(newVal) {
        if (newVal) {
          this.selectedClassList = _.map(newVal, (item) => {
            return item.id
          })
        }
      },
      deep: true,
    },
    // 允许更新必须允许导入
    'attributeForm.allowUpdate': {
      handler(newVal) {
        if (newVal) {
          this.attributeForm.allowImport = true
        }
      },
    },
    // 不允许导入就不能更新
    'attributeForm.allowImport': {
      handler(newVal) {
        if (!newVal) {
          this.attributeForm.allowUpdate = false
        }
      },
    },
    currentLang(val) {
      if (val === 'zh-Hans') {
        $('.el-popover__title').html('显示的列')
        return
      }
      $('.el-popover__title').html('columns displayed')
    },
    'attributeForm.isPrimary': {
      handler(newValue) {
        if (newValue) {
          this.attributeForm.referenceClassAttributeId = ''
          this.attributeForm.isNullable = true
          this.quoteDisabled = false
        }
      },
    },
    'attributeForm.isTag': {
      handler(newValue) {
        if (newValue) {
          this.attributeForm.valueType = 11
          return
        }
        this.attributeForm.valueType = ''
      },
    },
    'attributeForm.referenceClassAttributeId': {
      handler(newValue) {
        if (!newValue) {
          this.attributeForm.displayReferenceClassAttributeId = ''
        }
        if (newValue) {
          this.attributeForm.valueType = 1
          this.attributeForm.length = 36
          this.quoteDisabled = true
          this.bzsxDisabled = true
          this.changeYysx(newValue)
          return
        }
        this.quoteDisabled = false
        this.bzsxDisabled = false
      },
    },
    'attributeForm.valueType': {
      handler(newValue) {
        const attrType = 'length'
        if (newValue === 1) {
          this.attributeFormRules[attrType][0].required = true
          return
        }
        this.attributeFormRules[attrType][0].required = false
      },
    },
    standardId: {
      async handler(val) {
        if (val) {
          console.log(val, 'val123')
          this.getInfo()
          await this.getRelationLabel()
          await this.getMainDataType()
          console.log(val, 'changed standardID')
          this.currentSelectedGroup = null
          this.getClassList()
          this.getParentTypeList()
          // this.getTypeList()
          // this.getClassTypeAttributeList()
          this.tableAttrData = []
          this.totalClassSlection = []
        }
      },
    },
    classDialog(val) {
      if (!val) {
        this.classForm = {
          dynamicColumnData: [],
        }
        this.$refs.classForm.clearValidate()
        this.$refs.classForm.resetFields()
        this.classForm.dynamicColumnData.forEach((item) => {
          item.value = ''
        })
      }
    },
    attributeDialog(val) {
      if (!val) {
        this.attributeForm = {
          dynamicColumnData: [],
          identifierIdArr: [],
          isNullable: false,
          isPrimary: false,
          isImportant: false,
          isTag: false,
          isName: false,
          seqNo: 1,
          referenceDataClassId: '',
        }
        this.$refs.attributeForm.clearValidate()
        this.$refs.attributeForm.resetFields()
        this.attributeForm.dynamicColumnData.forEach((item) => {
          item.value = ''
        })
      }
    },
    'classForm.code': {
      handler(val) {
        if (val) {
          this.classForm.tableName = `${this.standardCode}_${this.classForm.code}`
        } else {
          this.classForm.tableName = ''
        }
      },
    },
  },
  methods: {
    handleUpload() {
      this.showUploadExtendedAttribute = true
    },

    classTreeMouseOver(node) {
      const offsetWidth = document.querySelector(`.${node}`).offsetWidth
      const clientWidth = document.querySelector(`.${node}`).parentNode.clientWidth
      if (offsetWidth <= clientWidth) {
        this.isShowTooltip = true
      } else {
        this.isShowTooltip = false
      }
    },
    // 属性分组树点击
    groupNodeClick(data) {
      this.currentSelectedGroup = data
      if (!_.isEmpty(this.currentSelectedGroup) && this.currentSelectedGroup.sourceType === 1) {
        this.groupClassDisabled = true
      } else {
        this.groupClassDisabled = false
      }
    },
    // 收缩实体树
    changeTreeMode() {
      this.isShowTreeMode = !this.isShowTreeMode
    },
    // 实体树数据勾选
    classCheckChange(node, checked) {
      if (this.isNodeClick) {
        this.isNodeClick = false
        return
      }
      const children = node.children || []
      // 勾选父级时选中所有子节点
      if (checked) {
        this.$refs.classTree.setChecked(node.id, true) // 确保父级被勾选
        children.forEach((child) => {
          this.$refs.classTree.setChecked(child.id, true) // 勾选所有子节点
        })
      } else {
        children.forEach((child) => {
          this.$refs.classTree.setChecked(child.id, false) // 取消勾选所有子节点
        })
        // 勾选所有子节点时不勾选父级
        const allChildrenChecked = children.every((child) => {
          return this.$refs.classTree.getCheckedNodes().includes(child)
        })

        if (allChildrenChecked) {
          this.$refs.classTree.setChecked(node.id, false) // 确保父级不被勾选
        }
      }
      this.totalClassSlection = this.$refs.classTree.getCheckedNodes()
    },
    // 实体树加载数据
    async loadClassTreeNode(node, resolve) {
      // console.log(node, 'nnnn')
      // if (node.level === 1) {
      const parameter = {
        standard_id: this.standardId,
        keyword: this.classKeyword,
        // class_type_id: this.classTypeId,
        std_class_type_attribute_cate_id: this.entityTypeId,
        // pageno: this.pageNoClass,
        // pagesize: this.pageSizeClass,
        data_type: this.classKeyword ? 1 : 0,
        parent_id: node.data?.id,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.nodeData = node
        node.data.children = res.data
        this.resolveData = resolve
        return resolve(res.data)
      }
      // }
      return resolve([])
    },
    // 获取主题下拉数据
    async getThemeList() {
      const parameter = {
        standard_id: this.standardId,
        pageno: 1,
        pagesize: 999,
      }
      const res = await StdSubjectDomainService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.themeList = _.sortBy(res.data, (item) => {
          return item.seqNo
        })
      }
    },
    clearReferenceAttribute() {
      this.attributeForm.referenceClassAttributeId = ''
      this.attributeForm.referenceClassAttributeName = ''
    },
    clearStandardAttribute() {
      this.attributeForm.attributeId = ''
      this.attributeForm.attributeName = ''
    },
    // 选择引用属性
    selectReferenceClassAttributeId(val) {
      this.attributeForm.referenceClassAttributeId = val.id
      this.attributeForm.referenceClassAttributeName = val.name
      this.showRefenenceDialog = false
      this.changeYysx(val.id, 'change')
    },
    // 选择标准属性
    selectAttributeId(val) {
      this.attributeForm.attributeId = val.id
      this.attributeForm.attributeName = val.name
      this.$set(this.attributeForm, 'referenceDataClassId', val.referenceDataClassId)
      this.showAttributeDialog = false
      this.changeCode(val.id)
    },
    setChildren(children, select) {
      // 编辑多个子层级
      children.map((j) => {
        this.toggleSelection(j, select)
        const index = _.findIndex(this.totalClassSlection, (item) => {
          return item.id === j.id
        })
        if (select) {
          if (index === -1) {
            this.totalClassSlection.push(j)
          }
        } else if (!select) {
          if (index !== -1) {
            this.totalClassSlection.splice(index, 1)
          }
        }
        if (j.children) {
          this.setChildren(j.children, select)
        }
        return j
      })
    },
    toggleSelection(row, select) {
      if (row) {
        this.$nextTick(() => {
          this.$refs.classTable && this.$refs.classTable.toggleRowSelection(row, select)
        })
      }
    },
    // 选中父节点时，子节点一起选中取消
    selectRow(selection, row) {
      const hasSelect = selection.some((el) => {
        return row.id === el.id
      })
      if (hasSelect) {
        this.totalClassSlection.push(row)
        if (row.children) {
          this.setChildren(row.children, true)
        } else {
          // 选择的子节点个数，是否与当前父节点的children个数一样
          const selectChild = _.filter(this.totalClassSlection, (item) => {
            return item.parentId === row.parentId
          })
          // 选中子节点，父节点一起选中
          this.tableClassData.forEach((item) => {
            if (item.id === row.parentId && selectChild.length === item.children.length) {
              this.toggleSelection(item, true)
              // 父节点往数组里添加
              this.totalClassSlection.push(item)
            }
          })
        }
      } else if (!hasSelect) {
        const index = _.findIndex(this.totalClassSlection, (item) => {
          return item.id === row.id
        })
        if (index !== -1) {
          this.totalClassSlection.splice(index, 1)
        }
        if (row.children) {
          this.setChildren(row.children, false)
        } else {
          // 取消子节点，父节点一起取消
          this.tableClassData.forEach((item) => {
            if (item.id === row.parentId) {
              this.toggleSelection(item, false)
              // 父节点从数组里删除
              const pIndex = _.findIndex(this.totalClassSlection, (tItem) => {
                return tItem.id === row.parentId
              })
              if (pIndex !== -1) {
                this.totalClassSlection.splice(pIndex, 1)
              }
            }
          })
        }
      }
    },
    // 选择全部
    selectAll(selection) {
      // tabledata第一层只要有在selection里面就是全选
      const isSelect = selection.some((el) => {
        const tableDataIds = this.tableClassData.map((j) => {
          return j.id
        })
        return tableDataIds.includes(el.id)
      })
      // tableDate第一层只要有不在selection里面就是全不选
      const isCancel = !this.tableClassData.every((el) => {
        const selectIds = selection.map((j) => {
          return j.id
        })
        return selectIds.includes(el.id)
      })
      if (isSelect) {
        selection.map((el) => {
          this.totalClassSlection.push(el)
          if (el.children) {
            // 解决子组件没有被勾选到
            this.setChildren(el.children, true)
          }
          return el
        })
      }
      if (isCancel) {
        this.tableClassData.map((el) => {
          const index = _.findIndex(this.totalClassSlection, (item) => {
            return item.id === el.id
          })
          if (index !== -1) {
            this.totalClassSlection.splice(index, 1)
          }
          if (el.children) {
            // 解决子组件没有被勾选到
            this.setChildren(el.children, false)
          }
          return el
        })
      }
    },
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await CommonService.downloadTemplateCommon({
        reqUrl: 'std/StdClass/download_import_template?filter_attribute_group=1',
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '类别导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      const res = await CommonService.uploadFile({
        reqUrl: 'std/StdClass/import',
        reqData: formData,
      })
      this.uploadFileProps.btnLoading = false
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '类别导入明细.xlsx',
          data: res,
        })
        this.clearLazyData()
        this.searchClass()
      }
    },
    // 导出
    async exportFile() {
      const res = await stdClassListService.exportFile({
        urlParam: `?standard_id=${this.standardId}`,
        ids: this.selectedClassList,
        downloadType: 0,
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '类别导出结果.xlsx',
          data: res,
        })
      }
    },
    // 是否为主数据(为否时，清空主数据类型)
    changeIsMainData(val) {
      if (!val) {
        //   this.classForm.dataMainTypeId = ''
      }
    },
    // 选择主数据
    changeMainData(val) {
      if (val) {
        this.classForm.isMainData = true
      } else {
        this.classForm.isMainData = false
      }
    },
    // 是否是类型（是时无法选择类型，且无法选择上级类别）
    changeIsType(val) {
      if (val) {
        this.classForm.stdClassTypeAttributeCateId = ''
        this.classForm.parentId = ''
      }
    },
    // 校验实体类型能否变更
    async checkClassType(classId, oldClassTypeId, classTypeId) {
      const res = await stdClassListService.checkClassType({
        classId,
        oldClassTypeId,
        classTypeId,
      })
      if (res && res.code === 0 && res.data) {
        this.$confirm(`${res.data}`, this.$t('tip'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        })
          .then(() => {
            this.updateClass()
          })
          .catch(() => {
            this.saveClassLoading = false
          })
      } else if (res && res.code === 0 && !res.data) {
        this.updateClass()
      } else {
        this.$message.warning(res.msg)
      }
    },
    // 获取主数据类型
    async getMainDataType() {
      const parameter = {
        SkipCount: 1,
        MaxResultCount: 999,
        Sorting: '',
      }
      const res = await MasterDataManageService.getList(parameter)
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.mainDataTypeList = res.data
      } else {
        this.mainDataTypeList = []
      }
    },
    refreshClassList() {
      this.getClassList()
    },
    async getPublishProgress(id) {
      if (!this.publishLoading) {
        return
      }
      // 获取发布进度
      const res = await stdClassListService.getPublishProgress(id)
      if (res.currentProgress === 100) {
        this.currentProgress = res.currentProgress
        this.publishLoading = false
        this.getProgress = false
        this.$message.success(this.$t('publishSuccess'))
        this.refreshClassList()
        return
      }
      if (res) {
        this.currentProgress = (res.currentProgress / res.total).toFixed(2) * 100
        this.getProgress = true
      }

      setTimeout(() => {
        this.getPublishProgress(id)
      }, 3000)
    },
    // 批量发布
    async batchPublish() {
      if (this.publishLoading) {
        return
      }
      if (_.isEmpty(this.selectedClassList)) {
        this.$message.warning(this.$t('pleaseSelectTheClassToPublish'))
        return
      }
      const tagClass = _.find(this.totalClassSlection, { code: 'Tag' })
      const documentClass = _.find(this.totalClassSlection, { code: 'Document' })
      if (!_.isNil(tagClass) && !_.isNil(documentClass)) {
        this.$message.warning(this.$t('tagAndDocumentCannotBePublishedSimultaneously'))
        return
      }
      this.publishLoading = true
      this.currentProgress = 0
      const checkPublishClassRes = await stdClassListService.newPublishList({
        classIds: this.selectedClassList,
        syncSubclass: null,
      })
      if (
        checkPublishClassRes &&
        checkPublishClassRes.code === 0 &&
        checkPublishClassRes.data !== 'confirmTip'
      ) {
        setTimeout(() => {
          this.getPublishProgress(checkPublishClassRes.data)
        }, 3000)
        return
      }
      // 有子类发布
      if (
        checkPublishClassRes &&
        checkPublishClassRes.code === 0 &&
        checkPublishClassRes.data === 'confirmTip'
      ) {
        this.$confirm(checkPublishClassRes.msg, this.$t('tip'), {
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no'),
          type: 'warning',
        })
          .then(async () => {
            const syncSubClassRes = await stdClassListService.newPublishList({
              classIds: this.selectedClassList,
              syncSubclass: true,
            })
            if (syncSubClassRes && syncSubClassRes.code === 0) {
              setTimeout(() => {
                this.getPublishProgress(syncSubClassRes.data)
              }, 3000)
            }
          })
          .catch(async () => {
            const asyncSubClassRes = await stdClassListService.newPublishList({
              classIds: this.selectedClassList,
              syncSubclass: false,
            })
            if (asyncSubClassRes && asyncSubClassRes.code === 0) {
              setTimeout(() => {
                this.getPublishProgress(asyncSubClassRes.data)
              }, 3000)
            }
          })
        return
      }
      this.publishLoading = false
    },
    // 取消发布
    async cancelPublish() {
      if (_.isEmpty(this.selectedClassList)) {
        this.$message.warning(this.$t('pleaseSelectTheClassToBeUnpublished'))
        return
      }
      this.unpublishLoading = true
      const checkCancelPublishClassRes = await stdClassListService.cancelPublish({
        classIds: this.selectedClassList,
        syncSubclass: null,
      })
      this.unpublishLoading = false
      // 没有子类，直接取消发布
      if (
        checkCancelPublishClassRes &&
        checkCancelPublishClassRes.code === 0 &&
        checkCancelPublishClassRes.data !== 'confirmTip'
      ) {
        this.$message.success(this.$t('unsubscribedClassSuccessfully'))
        this.refreshClassList()
        return
      }
      // 有子类，需要选择是否同步取消发布子类
      if (
        checkCancelPublishClassRes &&
        checkCancelPublishClassRes.code === 0 &&
        checkCancelPublishClassRes.data === 'confirmTip'
      ) {
        this.$confirm(checkCancelPublishClassRes.msg, this.$t('tip'), {
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no'),
          distinguishCancelAndClose: true,
          type: 'warning',
        })
          .then(async () => {
            this.unpublishLoading = true
            const syncCancelSubClassRes = await stdClassListService.cancelPublish({
              classIds: this.selectedClassList,
              syncSubclass: true,
            })
            this.unpublishLoading = false
            if (syncCancelSubClassRes && syncCancelSubClassRes.code === 0) {
              this.$message.success(this.$t('syncCancelPublishTheClassAndChildrenSuccessfully'))
              this.refreshClassList()
            }
          })
          .catch(async () => {
            const asyncCancelSubClassRes = await stdClassListService.cancelPublish({
              classIds: this.selectedClassList,
              syncSubclass: false,
            })
            this.unpublishLoading = false
            if (asyncCancelSubClassRes && asyncCancelSubClassRes.code === 0) {
              this.$message.success(this.$t('unsubscribedClassSuccessfully'))
              this.refreshClassList()
            }
          })
      }
    },
    // 局部刷新列表
    refreshRow(id) {
      if (this.maps.get(id)) {
        const { tree, treeNode, resolve } = this.maps.get(id)
        this.load(tree, treeNode, resolve)
      }
    },
    updateStandardId(val, code) {
      console.log('changed')
      this.standardId = val
      this.standardCode = code
      // 切换标准库时，清空table懒加载的数据
      this.clearLazyData()
    },
    async handleCommand(command, row) {
      console.log(command, row)
      if (command === 'delete') {
        this.delClass(row.id)
        await this.getAttributeGroupList()
        this.getAllAttributeList()
      } else if (command === 'record') {
        this.getChangeLogList(row.id)
      } else if (command === 'storage') {
        this.viewStorageSet(row)
      } else if (command === 'view') {
        this.viewClass(row.id)
      } else if (command === 'update') {
        this.saveClassLoading = false
        this.editClass(row.id)
      } else if (command === 'groupUpdate') {
        this.addAttrGroups('update', row)
      } else if (command === 'groupDelete') {
        this.removeAttributeGroup(row)
      }
    },
    // 数据脱敏规则列表
    async getDataDesensitizationRules() {
      const params = {
        SkipCount: 1,
        MaxResultCount: 999,
      }
      const res = await DesensitizationService.getList(params)
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.desensitizationList = res.data
      } else {
        this.desensitizationList = []
      }
    },
    // 参考数据列表
    async getReferenceData() {
      const params = {
        SkipCount: 0,
        MaxResultCount: 999,
        standardId: this.standardId,
      }
      const res = await ReferenceDataService.getCategory(params)
      if (res && res.code === 0 && res.data) {
        this.referenceDataList = res.data
      }
    },
    handleCurrentChangeStorage(num) {
      this.pageNoStorage = num
      this.getStorageList()
    },
    handleSizeChangeStorage(size) {
      this.pageSizeStorage = size
      this.getStorageList()
    },
    // 查看存储设置
    viewStorageSet(row) {
      this.currentStorage = row
      this.selectStorageId = row.id
      this.viewStorageTitle = `${row.name}:${row.code}`
      this.getStorageList()
    },
    // 查看存储设置列表
    async getStorageList() {
      this.storageLoading = true
      const parameter = {
        class_id: this.selectStorageId,
        keyword: '',
        pageno: this.pageNoStorage,
        pagesize: this.pageSizeStorage,
      }
      const res = await stdClassListService.getAttrList(parameter)
      if (res && res.code === 0 && res.data) {
        this.tableStorageData = res.data
        if (res.page) {
          this.recordCountStorage = res.page.recordCount
          this.pageNoStorage = res.page.pageNo
          this.pageSizeStorage = res.page.pageSize
        }
        this.storageLoading = false
        this.$nextTick(() => {
          this.$refs.storageTable?.doLayout()
        })
      }
    },
    renderSelectTable(initTableArr, selectionArr, domTable) {
      // 渲染选择的列表
      _.forEach(initTableArr, (item) => {
        if (_.find(selectionArr, ['id', item.parentId])) {
          this.$nextTick(() => {
            this.$refs[domTable].toggleRowSelection(item, true)
          })
        }
      })
    },
    async deleteClass() {
      if (!this.totalClassSlection.length) {
        this.$message({
          message: this.$t('selectClass'),
          type: 'warning',
        })
        return
      }
      this.$confirm(this.$t('confirmDeleteClass'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await stdClassListService.classRemove(
            _.map(this.totalClassSlection, (item) => {
              return item.id
            })
          )
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              message: res.msg,
            })
            this.pageNoClass = 1
            this.tableAttrData = []
            this.getClassList()
            this.clearLazyData()
          }
        })
        .catch(() => {})
    },
    onInput(value) {
      this.classForm.tableName = `${this.standardCode}_${value}`
    },
    // 获取上级类别列表
    async getParentTypeList() {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.parentTypeList = res.data
        this.classTypeAttributeList = _.filter(res.data, (item) => {
          return item.isType && item.approveStatus === 1
        })
      }
    },
    // 获取关联标识列表
    async getAttrRelationLabel() {
      const parameter = {
        identifier_type: 1,
      }
      const res = await StdIdentifierService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.attrRelationLabelList = res.data
      }
    },
    // 获取类别类型列表
    async getTypeList() {
      const parameter = {
        standard_id: this.standardId,
      }
      const res = await StdClassTypeService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.typeClassList = res.data
      }
    },
    // 获取类型列表(已发布)
    async getClassTypeAttributeList() {
      const params = {
        StandardId: this.standardId,
        SkipCount: 0,
        MaxResultCount: 1000,
      }
      const res = await EntityTypeService.getEntityTypeList(params)
      if (res && res.code === 0 && res.data) {
        this.classTypeAttributeList = _.filter(res.data, (item) => {
          return item.approveStatus === 1
        })
      }
    },
    // 获取实体标签列表
    async getClassLabelList() {
      const res = await stdClassLabelService.getClassLabelList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (res && res.code === 0) {
        this.classLabelList = res.data
      }
    },
    // 动态列表格去重
    unique(arr) {
      const hash = {}
      const newArr = arr.reduce((item, next) => {
        hash[next.value] ? '' : (hash[next.value] = true && item.push(next))
        return item
      }, [])
      return newArr
    },
    async getClassList(parentId, resolve) {
      this.classListLoading = true
      console.log(this.standardId, 'standardId')
      if (!this.standardId) {
        return
      }
      const parameter = {
        standard_id: this.standardId,
        keyword: this.classKeyword,
        // class_type_id: this.classTypeId,
        std_class_type_attribute_cate_id: this.entityTypeId,
        // pageno: this.pageNoClass,
        // pagesize: this.pageSizeClass,
        data_type: this.classKeyword ? 1 : 0,
        parent_id: parentId,
      }
      const res = await stdClassListService.getClassList(parameter)
      this.classListLoading = false
      if (res && res.code === 0 && res.data) {
        if (parentId) {
          this.handleChildren(this.tableClassData, res.data, parentId)
          resolve(res.data)
        } else {
          this.totalClassSlection = []
          this.tableClassData = res.data.map((item) => {
            item.publishOneLoading = false
            return item
          })
          this.renderSelectTable(this.tableClassData, this.totalClassSlection, 'classTable')
          // this.$nextTick(() => {
          //   this.$refs.classTable.doLayout()
          // })
          if (res.page) {
            this.pageNoClass = res.page.pageNo
            this.pageSizeClass = res.page.pageSize
            this.recordCountClass = res.page.recordCount
          }
        }
      }
    },
    // 将接口返回的children添加到表格的data里
    handleChildren(childList, data, parentId) {
      childList.map((item) => {
        if (item.id === parentId) {
          item.children = data
        } else if (item.id !== parentId && item.children) {
          this.handleChildren(item.children, data, parentId)
        }
        return item
      })
    },
    load(tree, treeNode, resolve) {
      this.maps.set(tree.id, { tree, treeNode, resolve })
      if (treeNode.level === 0 || treeNode.level === '') {
        this.getChildByList(tree.id, resolve)
        return resolve([])
      }
      return false
    },
    getChildByList(parentId, resolve) {
      this.getClassList(parentId, resolve)
    },
    searchClass() {
      this.getClassList()
    },
    async addClass() {
      this.classTitle = this.$t('createClass')
      this.classDialog = true
      this.saveClassLoading = false
      this.isPublished = false
      this.classForm = {
        dynamicColumnData: [],
        isMainData: false, // 新增类别，是否为主数据默认为否
        isType: false, // 新增类别，是否是类型默认为否
      }
      this.getParentTypeList()
      this.getClassLabelList()
      this.getThemeList()
      this.getPersonalityMetaDataList(0)
      this.classForm.seqNo = await this.getClassMaxSeqno()
    },
    // 新增获取最大序号值
    async getClassMaxSeqno() {
      const res = await stdClassListService.getClassMaxSeqno({
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return 1
    },
    async editClass(id) {
      this.classDialog = true
      this.classTitle = this.$t('editClass')
      this.currentClassRowId = id
      // await this.getTypeList()
      await this.getParentTypeList()
      await this.getClassLabelList()
      await this.checkIsPublished(id)
      await this.getPersonalityMetaDataList(0)
      this.getPersonalityMetaDataValue(id)
      const res = await stdClassListService.classDetail({ id })
      if (res && res.code === 0 && res.data) {
        this.classForm = res.data
        this.classForm.isMainData = this.classForm.isMainData === 1
        this.classForm.oldClassTypeId = this.classForm.stdClassTypeAttributeCateId
      }
    },
    // 判断实体是否发布过
    async checkIsPublished(id) {
      const res = await stdClassListService.checkIsPublished({ id })
      if (res && res.code === 0) {
        this.isPublished = res.data
      }
    },
    async viewClass(id) {
      this.classDialog = true
      this.classTitle = this.$t('classDetail')
      this.actionClassList = []
      const res = await stdClassListService.classDetail({ id })
      if (res && res.code === 0 && res.data) {
        this.classForm = res.data
        this.classForm.isMainData = this.classForm.isMainData === 1
      }
      await this.getPersonalityMetaDataList(0)
      this.getPersonalityMetaDataValue(id)
      this.getParentTypeList()
    },
    changeStatus(row, id, approveStatus) {
      if (approveStatus === 0) {
        this.$confirm(this.$t('whtherPublishClass'), this.$t('tip'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        }).then(async () => {
          const parameter = {
            classId: id,
          }
          row.publishOneLoading = true
          const res = await stdClassListService.publish(parameter)
          row.publishOneLoading = false
          if (res && res.code === 0) {
            this.$message.success(res.msg)
            this.clearLazyData()
            this.classStatus = 1
            this.getClassList()
          }
        })
      } else {
        this.$confirm(this.$t('changeStatusWorking'), this.$t('tip'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        }).then(() => {
          const parameter = {
            id,
            approveStatus: 0,
          }
          row.publishOneLoading = true
          stdClassListService.updateApproveStatus(parameter).then((res) => {
            row.publishOneLoading = false
            if (res && res.code === 0) {
              this.$message.success(res.msg)
              this.clearLazyData()
              this.classStatus = 0
              this.getClassList()
            }
          })
        })
      }
    },
    async delClass(id) {
      this.$confirm(this.$t('confirmDeleteClass'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await stdClassListService.classRemove([id])
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              message: res.msg,
            })
            this.pageNoClass = 1
            this.tableAttrData = []
            this.getClassList()
            this.clearLazyData()
            // this.clearLazyData()
            // if (this.tableClassData.length === 1 && this.pageNoClass > 1) {
            //   this.pageNoClass -= 1
            // }
            // this.tableAttrData = []
            // this.getClassList()
          }
        })
        .catch(() => {})
    },
    // 查询变更记录
    changeLogSearch() {
      this.changeLogPage.pageNo = 1
      this.getChangeLogList()
    },
    // 获取变更记录列表
    async getChangeLogList() {
      const params = {
        instance_source_id: this.currentRow.id,
        pageno: this.changeLogPage.pageNo,
        pagesize: this.changeLogPage.pageSize,
      }
      if (this.changelogSearchForm.changeType) {
        params.change_data_type = this.changelogSearchForm.changeType
      }
      if (this.changelogSearchForm.keyword) {
        params['remark[$text]'] = this.changelogSearchForm.keyword
      }
      this.changeLoading = true
      const res = await StdChangeRecordService.list(params)
      this.changeLoading = false
      if (res && res.code === 0 && res.data) {
        this.changeLogList = res.data
        this.changeLogPage.total = res.page.recordCount
      }
    },
    // 变更记录分页
    changeLogSizeChange(val) {
      this.changeLogPage.pageNo = 1
      this.changeLogPage.pageSize = val
      this.getChangeLogList()
    },
    async viewChangeDetail(id) {
      this.isShowDialog = true
      const parameter = {
        id,
      }
      const res = await StdChangeRecordService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.changeLogDetail = res.data
        if (JSON.stringify(this.changeLogDetail.dicAfterValue) === '{}') {
          this.changeLogDetail.dicAfterValue = {
            修改: this.changeLogDetail.remark,
          }
          this.changeLogDetail.dicBeforeValue = {
            修改: '',
          }
        }
      }
    },
    async handleSaveClass() {
      this.$refs.classForm.validate(async (valid) => {
        if (valid) {
          this.saveClassLoading = true
          if (this.classTitle === this.$t('createClass')) {
            this.saveClass()
          } else {
            // 修改类型
            if (
              this.classForm.oldClassTypeId &&
              this.classForm.stdClassTypeAttributeCateId &&
              this.classForm.oldClassTypeId !== this.classForm.stdClassTypeAttributeCateId
            ) {
              await this.checkClassType(
                this.classForm.id,
                this.classForm.oldClassTypeId,
                this.classForm.stdClassTypeAttributeCateId
              )
              return
            }
            this.updateClass()
          }
        }
      })
    },
    async saveClass() {
      const parameter = {
        model: this.classForm,
      }
      parameter.model.standardId = this.standardId
      parameter.model.standardCode = this.standardCode
      parameter.model.isMainData = parameter.model.isMainData ? 1 : 0
      const res = await stdClassListService.saveClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.savePersonalityMetaData(res.data.id)
        this.classDialog = false
        this.getClassList()
        this.$message({
          type: 'success',
          message: res.msg,
        })
        this.clearLazyData()
        await this.getAttributeGroupList()
        this.getAllAttributeList()
      }
      this.saveClassLoading = false
    },
    async updateClass() {
      const reqData = _.cloneDeep(this.classForm)
      reqData.standardCode = this.standardCode
      reqData.isMainData = reqData.isMainData ? 1 : 0
      delete reqData.createdTime
      const res = await stdClassListService.updateClassList({ model: reqData })
      this.saveClassLoading = false
      if (res && res.code === 0 && res.data) {
        this.savePersonalityMetaData(this.classForm.id)
        this.classDialog = false
        this.getClassList()
        this.$message({
          type: 'success',
          message: res.msg,
        })
        this.clearLazyData()
        await this.getAttributeGroupList()
        this.getAllAttributeList()
      }
    },
    // 清空table懒加载的数据
    clearLazyData() {
      this.$set(this.$refs.classTable.store.states, 'lazyTreeNodeMap', {})
      this.$set(this.$refs.classTable.store.states, 'treeData', {})
    },
    async handleCurrentChange(val, node) {
      this.$refs.classTree.setChecked(val.id, !node.checked)
      this.isNodeClick = true
      this.groupClassDisabled = false
      this.divideGroupSelected = ''
      this.currentSelectedGroup = null
      this.selectedGroup = []
      this.selectedClassId = val.id
      this.classStatus = val.approveStatus
      this.attrKeyword = ''
      this.currentRow = val
      await this.getAttributeGroupList()
      this.getAttrList()
      // this.getInfo()
      // this.getUnitList()
      this.getAllAttributeList()
      this.getChangeLogList(val.id)
      this.viewStorageSet(val)
    },
    handleTabClick(tab) {
      if (tab.name === 'attribute') {
        this.currentSelectedGroup = null
        this.getAttrList()
      }
    },
    // 获取单位列表
    async getUnitList() {
      const parameter = {
        standard_id: this.standardId,
        // pageno: this.unitPageNo,
        // pagesize: this.unitPageSize,
        sort: 'seq_no asc',
      }
      const res = await unitMeasureservice.unitList(parameter)
      if (res && res.code === 0 && res.data) {
        this.unitList = res.data
      }
    },
    handleCloseClass() {
      this.classDialog = false
    },
    // 获取所有属性
    async getAllAttributeList() {
      const parameter = {
        class_id: this.selectedClassId,
        keyword: this.attrKeyword,
        pageno: 1,
        pagesize: 999,
        group_id: null,
        is_all: true,
      }
      const res = await stdClassListService.getAttrList(parameter)
      if (res && res.code === 0 && res.data) {
        this.noGroupList = _.filter(res.data, (item) => {
          return item.attributeGroupId === null || item.attributeGroupId === ''
        })
        if (this.noGroupList.length) {
          const noGroup = _.find(this.attrGroups, ['name', '未分组'])
          if (!noGroup) {
            this.attrGroups.push({
              name: '未分组',
            })
          }
        } else {
          const noGroup = _.find(this.attrGroups, ['name', '未分组'])
          if (noGroup) {
            this.attrGroups.splice(this.attrGroups.indexOf(noGroup), 1)
          }
        }
        this.currentSelectedGroup = null
        this.selectedGroup = []
      }
    },
    async getAttrList() {
      this.attrListLoading = true
      const parameter = {
        class_id: this.selectedClassId,
        keyword: this.attrKeyword,
        pageno: this.pageNoAttr,
        pagesize: this.pageSizeAttr,
        group_id: this.currentSelectedGroup?.id,
        is_all: true,
      }
      const res = await stdClassListService.getAttrList(parameter)
      if (res && res.code === 0 && res.data) {
        this.tableAttrData = res.data
        this.tableAttrData.forEach((item) => {
          if (item.sourceType && item.sourceType === 1) {
            item.disabled = true
          }
        })
        if (res.page) {
          this.recordCountAttr = res.page.recordCount
          this.pageNoAttr = res.page.pageNo
          this.pageSizeAttr = res.page.pageSize
        }
        this.attrListLoading = false
      }
    },
    searchAttr() {
      if (this.selectedClassId) {
        this.getAttrList()
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('selectClass'),
        })
      }
    },
    handleCurrentChangeClass(num) {
      this.pageNoClass = num
      this.getClassList()
    },
    handleSizeChangeClass(size) {
      this.pageSizeClass = size
      this.getClassList()
    },
    handleCurrentChangeAttr(num) {
      this.pageNoAttr = num
      this.getAttrList()
    },
    handleSizeChangeAttr(size) {
      this.pageSizeAttr = size
      this.getAttrList()
    },
    changeColumnAttr(data) {
      if (data.length === 0 && this.tableAttrFilterHeader.length === 1) {
        this.$message({
          type: 'warning',
          message: this.$t('pleaseSelectAtLeaseOneTableHeader'),
        })
        return
      }
      this.columnVisibleAttr = data
      this.tableAttrFilterHeader = _.filter(this.tableAttrHeader, (item) => {
        return _.includes(data, item.value)
      })
      this.$nextTick(() => {
        if (this.$refs.attrTable) {
          this.$refs.attrTable.doLayout()
        }
      })
    },
    changeColumnClass(data) {
      if (data.length === 0 && this.tableClassFilterHeader.length === 1) {
        this.$message({
          type: 'warning',
          message: this.$t('pleaseSelectAtLeaseOneTableHeader'),
        })
        return
      }
      this.columnVisibleClass = data
      this.tableClassFilterHeader = _.filter(this.tableClassHeader, (item) => {
        return _.includes(data, item.value)
      })
      this.$nextTick(() => {
        if (this.$refs.classTable) {
          this.$refs.classTable.doLayout()
        }
      })
    },
    isShowRigth() {
      this.showRigth = !this.showRigth
      if (!this.showRigth) {
        document.getElementById('leftCol').className = 'el-col el-col-24'
      } else {
        document.getElementById('leftCol').className = 'el-col el-col-12'
      }
      this.$nextTick(() => {
        if (this.$refs.classTable) {
          this.$refs.classTable.doLayout()
        }
      })
    },
    isShowLeft() {
      this.showLeft = !this.showLeft
      if (!this.showLeft) {
        document.getElementById('rightCol').className = 'el-col el-col-24'
      } else {
        document.getElementById('rightCol').className = 'el-col el-col-12'
      }
      this.$nextTick(() => {
        if (this.$refs.attrTable) {
          this.$refs.attrTable.doLayout()
        }
      })
    },
    async addAttr() {
      this.getPersonalityMetaDataList(1)
      if (!this.selectedClassId) {
        this.$message({
          message: this.$t('selectClass'),
          type: 'warning',
        })
        return
      }
      this.attributeDialog = true
      this.attributeTitle = this.$t('createAttribute')
      this.bzsxDisabled = false
      this.attributeForm = {
        dynamicColumnData: [],
        // identifierIdArr: [],
        unitId: '',
        isNullable: false,
        isPrimary: false,
        isImportant: false,
        isTag: false,
        isName: false,
        seqNo: 1,
        code: '',
        name: '',
        valueType: '',
        decimalPoint: '',
        length: '',
        allowExport: true,
        allowImport: true,
        allowUpdate: true,
        isQuery: true,
        isDisplay: false, // true是不勾选，false是勾选
        attributeName: '',
        referenceClassAttributeName: '',
        referenceClassAttributeId: '',
        displayReferenceClassAttributeId: '',
        extendClassList: [],
      }
      this.extendClassList = []
      this.attributeForm.seqNo = await this.getAttrMaxSeqno()
    },
    // 新增获取最大序号值
    async getAttrMaxSeqno() {
      const res = await stdClassListService.getAttrMaxSeqno({
        classId: this.currentRow.id,
      })
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return 0
    },
    // 获取新增，更新准备数据
    async getInfo() {
      // 获取标准属性列表
      this.getStandardAttrList()
      // 获取属性分组列表
      // await this.getAttributeGroupList()
      // 获取引用数据
      await this.getYysxList()
      // 获取关联标签列表
      await this.getAttrRelationLabel()
      // 获取值类型列表
      await this.getValueTypeList()
      // 获取数据脱敏规则
      await this.getDataDesensitizationRules()
      // 获取参考数据
      await this.getReferenceData()
      // 获取扩展属性列表
      await this.geteExtendList()
      // 获取单位
      this.getUnitList()
    },
    async getStandardAttrList(val) {
      if (!this.standardId) {
        return
      }
      const parameter = {
        standard_id: this.standardId,
        keyword: val,
      }
      const res = await stdClassListService.getStandardAttrList(parameter)
      if (res && res.code === 0 && res.data) {
        this.standardAttrList = _.map(res.data, (item) => {
          item.label = `${item.name}  ${item.code}`
          return item
        })
      }
    },
    // 获取属性分组列表
    // async getAttributeGroupList() {
    //   const parameter = {
    //     standard_id: this.standardId,
    //   }
    //   const res = await StdClassAttributeGroupService.list(parameter)
    //   if (res && res.code === 0 && res.data) {
    //     this.attributeGroupList = res.data
    //   }
    // },
    // 获取引用数据
    async getYysxList() {
      const parameter = {
        standard_id: this.standardId,
        is_primary: true,
      }
      const res = await StdClassAttributeService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.quoteList = res.data
      }
    },
    // 获取关联标签列表
    async getRelationLabel() {
      const parameter = {
        identifier_type: 0, // 代表类别标识
      }
      const res = await StdIdentifierService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.classRelationLabelList = res.data
      }
    },
    // 获取值类型列表
    async getValueTypeList() {
      const res = await StdClassAttributeService.getValueType()
      if (res && res.code === 0 && res.data) {
        this.valueTypeList = res.data
      }
    },
    // 属性列表查看详情
    async viewAttr(row) {
      await this.getInfo()
      this.currentAttribute = row
      this.attributeTitle = this.$t('attributeDetail')
      this.actionLabelList = []
      await this.getPersonalityMetaDataList(1)
      this.getPersonalityMetaDataValue(row.id)
      const res = await StdClassAttributeService.detail({
        id: row.id,
      })
      if (res && res.code === 0 && res.data) {
        this.attributeForm = _.cloneDeep(res.data)
        this.attributeForm.isDisplay = !this.attributeForm.isDisplay
        if (this.attributeForm.displayReferenceClassAttributeId) {
          this.attributeForm.displayReferenceClassAttributeId = this.attributeForm.displayReferenceClassAttributeId.split(
            ','
          )
        }
        this.attributeDialog = true
        this.$nextTick(() => {
          this.$set(this.attributeForm, 'valueType', res.data.valueType)
        })
        this.extendClassList = this.attributeForm.extendClassList
      }
    },
    // 属性列表编辑
    async editAttr(id) {
      await this.getInfo()
      this.attributeTitle = this.$t('editAttribute')
      this.actionLabelList = []
      const res = await StdClassAttributeService.detail({
        id,
      })
      if (res && res.code === 0 && res.data) {
        this.attributeForm = _.cloneDeep(res.data)
        this.attributeForm.isDisplay = !this.attributeForm.isDisplay
        if (this.attributeForm.displayReferenceClassAttributeId) {
          this.attributeForm.displayReferenceClassAttributeId = this.attributeForm.displayReferenceClassAttributeId.split(
            ','
          )
        }
        this.attributeDialog = true
        this.$nextTick(() => {
          this.$set(this.attributeForm, 'valueType', res.data.valueType)
        })
        this.extendClassList = this.attributeForm.extendClassList
      }
      await this.getPersonalityMetaDataList(1)
      this.getPersonalityMetaDataValue(id)
      // 获取关联标签列表
      await this.getAttrRelationLabel()
    },
    delAttr(id) {
      this.$confirm(this.$t('deleteClassAttribute'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await StdClassAttributeService.remove({
            data: [id],
          })
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: 'success',
            })
            if (this.tableAttrData.length === 1 && this.pageNo > 1) {
              this.pageNoAttr -= 1
            }
            this.getAttrList()
            this.getAllAttributeList()
          }
        })
        .catch(() => {})
    },
    handleSelectionChange(val) {
      this.multipleSelectionId = val.map((item) => {
        return item.id
      })
      this.arrtibuteSelect = val
    },
    delMoreAttr() {
      if (!this.multipleSelectionId.length) {
        this.$message({
          message: this.$t('deleteTheClassAttribute'),
          type: 'warning',
        })
        return
      }
      // 类型属性不能删除
      const noDelList = _.filter(this.arrtibuteSelect, (item) => {
        return item.sourceType === 1
      })
      if (noDelList.length > 0) {
        this.$message.warning('类型属性不能删除')
        return
      }
      this.$confirm(this.$t('deleteClassAttribute'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await StdClassAttributeService.remove({
            data: this.multipleSelectionId,
          })
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: 'success',
            })
            if (this.tableAttrData.length === 1 && this.pageNo > 1) {
              this.pageNoAttr -= 1
            }
            this.getAttrList()
            this.getAllAttributeList()
          }
        })
        .catch(() => {})
    },
    attributeFormClose() {
      this.attributeDialog = false
      this.extendClassList = []
    },
    attributeFormSave() {
      this.$refs.attributeForm.validate((valid) => {
        if (valid) {
          if (this.attributeForm.valueType === 1 && this.attributeForm.length <= 0) {
            this.$message.warning('请输入有效字符串长度')
            return
          }
          // 禁止导入的属性必须符合以下之一：
          // 1.属性可以为空
          // 2.属性不允许为空但设置了默认值
          if (
            !this.attributeForm.allowImport &&
            this.attributeForm.isNullable &&
            (this.attributeForm.defaultValue === undefined ||
              this.attributeForm.defaultValue === '')
          ) {
            this.$message.warning('禁止导入请填写默认值')
            return
          }
          this.disabledAttrBtn = true
          this.attributeForm.extendClassList = this.extendClassList
          const form = _.cloneDeep(this.attributeForm)
          // 引用显示属性改为多选
          if (
            form.displayReferenceClassAttributeId &&
            Array.isArray(form.displayReferenceClassAttributeId)
          ) {
            form.displayReferenceClassAttributeId = form.displayReferenceClassAttributeId.join(',')
          }
          if (this.attributeTitle === this.$t('createAttribute')) {
            this.addAttribute(form)
          } else {
            this.updateAttribute(form)
          }
        }
      })
    },
    async addAttribute(form) {
      const parameter = {
        model: form,
      }
      parameter.model.classId = this.selectedClassId
      parameter.model.isDisplay = !form.isDisplay
      const res = await stdClassListService.saveAttrList(parameter)
      if (res && res.code === 0 && res.data) {
        this.savePersonalityMetaData(res.data.id)
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.attributeDialog = false
        this.getAttrList()
        this.getAllAttributeList()
      }
      this.disabledAttrBtn = false
    },
    async updateAttribute(form) {
      const parameter = {
        model: form,
      }
      parameter.model.classId = this.selectedClassId
      parameter.model.isDisplay = !form.isDisplay
      const res = await stdClassListService.updateAttrList(parameter)
      if (res && res.code === 0) {
        this.savePersonalityMetaData(form.id)
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.attributeDialog = false
        this.getAttrList()
        this.getAllAttributeList()
      }
      this.disabledAttrBtn = false
    },
    changeCode(val) {
      let obj = {}
      this.standardAttrList.forEach((item) => {
        if (item.id === val) {
          obj = item
        }
      })
      this.attributeForm.code = obj.code
      this.attributeForm.name = obj.name
      this.attributeForm.valueType = obj.valueType
      if (obj.valueType === 11) {
        this.attributeForm.isTag = true
      }
      this.attributeForm.unitId = obj.unitId
      // this.attributeForm.identifierIds = obj.identifierIds
      this.attributeForm.decimalPoint = obj.decimalPoint
      this.attributeForm.length = obj.length
      this.attributeForm.attributeId = obj.id
      this.attributeForm.attributeName = obj.name
    },
    async changeYysx(id, from) {
      if (id === '') {
        return
      }
      const parameter = {
        classId: '',
      }
      this.quoteList.forEach((item) => {
        if (item.id === id) {
          if (from === 'change') {
            this.changeCode(item.attributeId)
          }
          parameter.classId = item.classId
        }
      })
      const res = await stdClassDataService.inherit(parameter)
      if (res && res.code === 0 && res.data) {
        res.data.items.forEach((item) => {
          this.$set(item, 'value', item.id)
        })
        this.displayReferenceClassAttributeArr = res.data.items
      }
    },
    async checkDefaultValue() {
      const parameter = {
        valueType: this.attributeForm.valueType,
        defaultValue: this.attributeForm.defaultValue,
      }
      if (this.attributeForm.valueType && this.attributeForm.defaultValue) {
        const res = await StdClassAttributeService.getValidDefaultValueResult(parameter)
        if (res && res.code === 0) {
          // this.$message({
          //   message: res.msg,
          //   type: 'success',
          // })
        }
      }
    },
    async checkRuleExpression() {
      const parameter = {
        classId: this.selectedClassId,
        ruleExpression: this.attributeForm.ruleExpression,
      }
      if (this.attributeForm.ruleExpression) {
        const res = await StdClassAttributeService.getValidRuleExpression(parameter)
        if (res && res.code === 0) {
          this.$message({
            message: res.msg,
            type: 'success',
          })
        }
      }
    },
    // 属性分组按钮
    selectedGroupChange(val) {
      if (this.selectedGroup.length > 1) {
        this.selectedGroup.splice(0, 1)
      }
      if (val) {
        this.currentSelectedGroup = this.attrGroups.find((item) => {
          return val[0] === item.name
        })
      }
      if (!_.isEmpty(this.currentSelectedGroup) && this.currentSelectedGroup.sourceType === 1) {
        this.groupClassDisabled = true
      } else {
        this.groupClassDisabled = false
      }
    },
    // 新增属性分组
    addAttrGroups(val, row) {
      if (val === 'create') {
        this.attrGropsForm.seqNo = ''
        this.attrGropsForm.name = ''
        this.attrGroupsTitle = this.$t('create')
        this.attrGropsDialogVisible = true
      } else if (val === 'update') {
        if (!row) {
          this.$message.warning(this.$t('pleaseSelectGroupYouWantToEdit'))
          return
        }
        if (row.sourceType === 1) {
          this.$message.info(this.$t('entitiesOrDocumentsCannotBeEdited'))
          return
        }
        this.attrGropsDialogVisible = true
        this.attrGroupsTitle = this.$t('edit')
        this.getAttributeGroup()
      }
      if (this.$refs.attrGropsForm) {
        this.$refs.attrGropsForm.clearValidate()
      }
    },
    // 保存属性分组
    attrGropsFormSave() {
      this.$refs.attrGropsForm.validate(async (valid) => {
        if (valid) {
          if (this.attrGropsForm.name === '未分组') {
            this.$message.warning(this.$t('groupNameCannotBeUngrouped'))
            return
          }
          if (this.attrGroupsTitle === this.$t('create')) {
            this.attrGropsFormSaveLoading = true
            const res = await stdClassListService.addAttributeGroup({
              ...this.attrGropsForm,
              classId: this.currentRow.id,
              standardId: this.currentRow.standardId,
            })
            this.attrGropsFormSaveLoading = false
            if (res && res.code === 0) {
              this.attrGropsDialogVisible = false
              this.$message.success(this.$t('AddSuccess'))
              this.getAttributeGroupList()
              this.getAllAttributeList()
            }
          } else {
            this.attrGropsFormSaveLoading = true
            const res = await stdClassListService.updateAttributeGroup({
              ...this.attrGropsForm,
            })
            this.attrGropsFormSaveLoading = false
            if (res && res.code === 0) {
              this.attrGropsDialogVisible = false
              this.$message.success(this.$t('editedSuccessfully'))
              this.getAttributeGroupList()
              this.getAllAttributeList()
            }
          }
        }
      })
    },
    // 获取属性分组列表
    async getAttributeGroupList() {
      const res = await stdClassListService.getAttributeGroupList({
        classId: this.currentRow.id,
        filter: this.attrKeyword,
      })
      if (res && res.code === 0 && res.data) {
        this.attrGroups = []
        this.attrGroups = res.data
        // 是类型，选择分组就显示对象或文档;否则，不显示
        this.selectGroupList = _.filter(res.data, (item) => {
          return item.sourceType === 0
        })
      } else {
        this.attrGroups = []
        this.selectGroupList = []
        this.currentSelectedGroup = null
        this.selectedGroup = []
      }
    },
    // 获取属性分组
    async getAttributeGroup() {
      const res = await stdClassListService.getAttributeGroup(this.currentSelectedGroup.id)
      if (res && res.code === 0) {
        this.attrGropsForm = res.data
      }
    },
    // 删除属性分组
    async removeAttributeGroup() {
      if (!this.currentSelectedGroup) {
        this.$message.warning(this.$t('selectAttributeGroupYouWantToDelete'))
        return
      }
      if (this.currentSelectedGroup.sourceType === 1) {
        this.$message.info(this.$t('entitiesDocumentsCannotBeDeleted'))
        return
      }
      this.$confirm(this.$t('deleteAttributeGrouping'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await stdClassListService.removeAttributeGroup(this.currentSelectedGroup.id)
          if (res && res.code === 0) {
            this.$message.success(this.$t('DeleteSuccessful'))
            this.getAttributeGroupList()
            this.getAllAttributeList()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 分组
    divideGroup() {
      if (this.groupClassDisabled) {
        this.$message.info(this.$t('cannotBeGrouped'))
        return
      }
      if (!this.multipleSelectionId.length) {
        this.$message.warning(this.$t('tickData'))
        return
      }
      this.attrKeyword = ''
      this.divideGroupDialogVisible = true
    },
    // radio取消选择
    radioClick(e) {
      if (e.name === this.divideGroupSelected) {
        this.divideGroupSelected = ''
        this.currentDivideGroup = ''
      } else {
        this.divideGroupSelected = e.name
        this.currentDivideGroup = e
      }
    },
    // 操作分组
    operateGroup() {
      if (this.currentDivideGroup) {
        this.setAttributeGroup()
      } else {
        this.moveGroup()
      }
    },
    // 设置分组
    async setAttributeGroup() {
      const res = await stdClassListService.setAttributeGroup({
        groupId: this.currentDivideGroup.id,
        classAttributeId: this.multipleSelectionId,
      })
      if (res && res.code === 0) {
        this.$message.success(this.$t('setGroupSuccessful'))
        this.divideGroupDialogVisible = false
        this.searchAttr()
        this.getAllAttributeList()
        this.divideGroupSelected = ''
        this.currentDivideGroup = null
      }
    },
    // 移除分组
    async moveGroup() {
      let groupId = null
      _.map(this.attrGroups, (item) => {
        if (item.name === this.selectedGroup[0]) {
          groupId = item.id
        }
      })
      const res = await stdClassListService.moveGroup({
        groupId,
        classAttributeId: this.multipleSelectionId,
      })
      if (res && res.code === 0) {
        this.$message.success(this.$t('removeGroupSuccessful'))
        this.divideGroupDialogVisible = false
        this.searchAttr()
        this.getAllAttributeList()
        this.divideGroupSelected = ''
        this.currentDivideGroup = null
      }
    },
    // 获取实体列表
    async geteExtendList() {
      const parameter = {
        data_type: 1,
        standard_id: this.standardId,
        subject_domain_id: this.themeId,
        approve_status: 1, // 已发布
        is_type: false, // 是否为类型
      }
      const res = await StdClassTreeService.getTreeList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
      }
    },
    // 扩展属性变更
    isExtendChange(val) {
      if (!val) {
        this.extendClassList = []
      }
    },
    saveExtendClassList(val) {
      this.extendClassList = val
    },
    // 关闭扩展属性弹框
    closeExtendedPropertiesDialog(val) {
      this.extendedPropertiesDialog = val
    },
    // 扩展属性删除
    removeExtendClass(item, index) {
      this.extendClassList.splice(index, 1)
    },
    // 获取个性化元数据列表
    async getPersonalityMetaDataList(type) {
      this.personalityMetaData = []
      const res = await StdClassAttributeService.getPersonalityMetaDataList({
        StdPersonalityMetaDataType: type,
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        this.personalityMetaData = res.data.map((item) => {
          item.dataValue = null
          return item
        })
      }
    },
    // 保存个性化元数据
    async savePersonalityMetaData(id) {
      const params = []
      this.personalityMetaData.forEach((item) => {
        params.push({
          dataId: id,
          stdPersonalityMetaDataId: item.id,
          dataValue: item.dataValue,
        })
      })
      await StdClassAttributeService.savePersonalityMetaData(params)
    },
    // 编辑时获取个性化元数据值
    async getPersonalityMetaDataValue(id) {
      const res = await StdClassAttributeService.getPersonalityMetaDataValue({
        dataId: id,
      })
      if (res && res.code === 0) {
        this.personalityMetaData.map((item) => {
          res.data.forEach((val) => {
            if (item.columnName === val.columnName) {
              this.$set(item, 'dataValue', val.dataValue)
            }
          })
          return item
        })
      }
    },
    // 元数据输入框值变化
    metaDataInputChange(val, type, item) {
      // console.log((/^[+]{0,1}(\d+)$/g).test(val), '0000000')
      if (type === '2') {
        // 整数
        item.dataValue = val.replace(/[^0-9]/g, '')
      } else if (type === '3') {
        // 小数
        item.dataValue = val.replace(/[^0-9.]/g, '')
      }
    },
    // 打开分析弹框
    async openEffectAnalysis(type) {
      if (!this.multipleSelectionId.length) {
        this.$message.warning(this.$t('tickData'))
        return
      }
      if (this.multipleSelectionId.length > 1) {
        this.$message.warning('请选择单个属性进行分析')
        return
      }
      let res = null
      if (type === 'effect') {
        // 影响分析
        this.analysisTitle = '影响分析'
        this.analysisType = 'effect'
        this.effectLoading = true
        res = await stdClassListService.getImpactAnalysis({ id: this.multipleSelectionId[0] })
        this.effectLoading = false
      } else {
        // 血缘分析
        this.analysisTitle = '血缘分析'
        this.analysisType = 'blood'
        this.bloodLoading = true
        res = await stdClassListService.getAncestryAnalysis({ id: this.multipleSelectionId[0] })
        this.bloodLoading = false
      }
      this.effectAnalysisData = []
      if (res && res.code === 0 && res.data) {
        this.showEffectAnalysisDialog = true
        this.effectAnalysisData.push(res.data)
      }
    },
  },
}
</script>
<style lang="scss">

.input-extendProperty.el-input-group--append.el-input-group {
  .el-input-group__append {
    width: 100px !important;
    padding: 0 !important;
    .el-button {
      margin: 0 !important;
      flex: 1;
      height: 100% !important;
      i {
        font: 20px;
      }
    }
  }

  height: 100px !important;
  .el-input__inner {
    height: 100px !important;
  }
  .el-input__prefix {
    overflow-y: auto !important;
    padding: 5px;
    width: calc(100% - 107px) !important;
    > div {
      text-align: left;
    }
  }
}

</style>
<style lang="scss" scoped>

#classList {
  .btnBox {
    justify-content: flex-end;
  }
  .tableBox {
    height: calc(100% - 210px) !important;
  }
  .tableleftBox {
    height: calc(100% - 103px) !important;
  }
  /deep/.el-table__expand-icon {
    display: inline-block;
  }
  /deep/.el-dialog__body {
    padding: 20px !important;
  }
  /deep/.el-input-number.is-without-controls .el-input__inner {
    text-align: left;
  }
  /deep/.el-table__body-wrapper {
    // height: calc(100% - 70px);
  }
  /deep/.el-card__body {
    height: 100%;
  }
  /deep/ .attribute-checkbox .el-checkbox-button__inner {
    border: 1px solid #dcdfe6 !important;
    border-radius: 4px !important;
  }
  /deep/ .attribute-checkbox .el-checkbox-button.is-checked .el-checkbox-button__inner {
    box-shadow: none !important;
  }
  /deep/ .divide-group_radio .el-radio {
    display: block;
  }
  /deep/ .el-table:before {
    background-color: transparent !important;
  }
}
.main-box {
  height: calc(100% - 42px);
}
.storageBox {
  height: 100%;
  .table-box {
    height: calc(100% - 90px);
    /deep/.el-table__body-wrapper {
      height: calc(100% - 37px) !important;
    }
  }
}
.can-not-input {
  ::v-deep input {
    pointer-events: none;
  }
}
.transform-rotate-90 {
  transform: rotate(90deg);
}
.icon-bg-circleLeft:before {
  color: var(--buttonPrimaryBg);
}
.icon-bg-circleRight:before {
  color: var(--buttonPrimaryBg);
}
.icon-line-collection:before {
  color: var(--buttonPrimaryBg);
}
.icon-bg-collection:before {
  color: var(--buttonPrimaryBg);
}
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/ .el-tree-node__content {
  height: 32px !important;
  line-height: 32px !important;
}
.el-icon-lock {
  color: #0082ff !important;
}

</style>
